import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import classList from 'flarum/common/utils/classList';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import DiscussionListItem from 'flarum/forum/dianLiang/DlDiscussionListItem';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import extractText from 'flarum/common/utils/extractText';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import TagSelectionModal from 'flarum/tags/components/TagSelectionModal';
import tagIcon from 'flarum/tags/helpers/tagIcon';
import tagLabel from 'flarum/tags/helpers/tagLabel';
import highlight from 'flarum/common/helpers/highlight';
import PostControls from 'flarum/forum/utils/PostControls';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import CommentPost from 'flarum/forum/components/CommentPost';
import Dropdown from 'flarum/common/components/Dropdown';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import PagePage from '../common/models/PagePage';
import LogInModal from 'flarum/forum/components/LogInModal';
import Link from 'flarum/common/components/Link';
import humanTime from 'flarum/common/utils/humanTime';
import listItems from 'flarum/common/helpers/listItems';
import type Mithril from 'mithril';
import Post from 'flarum/forum/components/Post';
import Select from 'flarum/common/components/Select';
import icon from 'flarum/helpers/icon';
import CommentModal from 'flarum/forum/dianLiang/CommentModal';
import MallPage from 'flarum/forum/dianLiang/MallPage';
import HeaderView from './components/HeaderView';
import NavigationBar from './components/NavigationBar';
import HeaderSlideCarousel from './components/HeaderSlideCarousel';
import IndexPage from 'flarum/forum/components/IndexPage';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import ItemList from 'flarum/common/utils/ItemList';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import ChatRoom from 'flarum/forum/components/ChatRoom';
import NotificationsDropdown from 'flarum/forum/components/NotificationsDropdown';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import LinkButton from 'flarum/common/components/LinkButton';
import Separator from 'flarum/common/components/Separator';
import SearchView from '../forum/components/SearchView';
import SearchButton from '../common/components/SearchButton';
import FloatPromptButton from '../common/components/FloatPromptButton';
import avatar from 'flarum/common/helpers/avatar';
import TagsPage from 'flarum/forum/tags/components/TagsPage';
import PagePagePC from './components/PagePagePC';
import SearchSource from 'flarum/forum/components/Search';
import ComposerBody from 'flarum/forum/components/ComposerBody';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import Navigation from 'flarum/common/components/Navigation';
import PostButton from '../common/components/PostButton';
import ResponseItemsBtn from 'flarum/common/components/ResponseItemsBtn';
import UploadFileButton from '../common/components/UploadFileButton';
import HomePage from './components/HomePage';
import TagView from './components/TagView';
import TextEditor from 'flarum/common/components/TextEditor';
import ComposerState from 'flarum/forum/states/ComposerState';
import Composer from 'flarum/forum/components/Composer';
import NotificationsPage from 'flarum/forum/components/NotificationsPage';
import Page from 'flarum/common/components/Page';
import NotificationList from 'flarum/forum/components/NotificationList';
import NotificationListState from 'flarum/forum/states/NotificationListState';
import DiscussionListPane from 'flarum/forum/components/DiscussionListPane';
import PostUser from 'flarum/forum/components/PostUser';
import PostStream from 'flarum/forum/components/PostStream';
import PostLoading from 'flarum/forum/components/LoadingPost';
import SubscriptionMenu from 'flarum/subscriptions/components/SubscriptionMenu';
import username from 'flarum/common/helpers/username';
import nickname from 'flarum/common/helpers/nickname';
import UserCard from 'flarum/forum/components/UserCard';
import UserPage from 'flarum/forum/components/UserPage';
import LikePage from 'flarum/forum/dianLiang/LikePage';
import MentionPage from 'flarum/forum/dianLiang/MentionPage';
import SettingPage from 'flarum/forum/dianLiang/SettingPage';
import LikesPage from 'flarum/forum/dianLiang/LikesPage';
import PayPage from 'flarum/forum/dianLiang/PayPage';
import MallOrderPage from 'flarum/forum/dianLiang/MallOrderPage';
import CommentsPage from 'flarum/forum/dianLiang/CommentsPage';
import ProfilePagePhone from 'flarum/forum/dianLiang/ProfilePagePhone';
import ReplyPlaceholder from 'flarum/forum/components/ReplyPlaceholder';
import FlagsPage from 'flarum/flags/components/FlagsPage';
import ForumApplication from 'flarum/forum/ForumApplication';
import FloatPostButton from '../common/components/FloatPostButton';
import EditPostComposer from 'flarum/forum/components/EditPostComposer';
import CommentUtil from 'flarum/common/dianliang/commentUtil';
import RouteToBindRoleModal from 'flarum/common/dianliang/RouteToBindRoleModal';
import RoleBindingModal from 'flarum/forum/dianLiang/RoleBindingModal';
import RoleBindConfirmModal from 'flarum/forum/dianLiang/RoleBindConfirmModal';
import ChangePasswordModal from 'flarum/forum/components/ChangePasswordModal';
import Md5Util from 'flarum/common/dianliang/Md5Util';
import ConfirmDocumentUnload from 'flarum/common/components/ConfirmDocumentUnload';
import Stream from 'flarum/common/utils/Stream';
import ComposerPostPreview from 'flarum/forum/components/ComposerPostPreview';
import TagViewPC from './components/TagViewPC';
import WiKiPage from './components/WiKiPage';
import SkyspirePage from './components/SkyspirePage';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';
import NickNameModal from 'flarum/nickNames/components/NickNameModal';
import SignNameModal from '../common/components/SignNameModal';
import signName from 'flarum/forum/dianLiang/signName';
import ExperienceValuelBar from '../common/components/ExperienceValuelBar';
import TextEditorButton from 'flarum/components/TextEditorButton';
import PostStreamState from 'flarum/states/PostStreamState';
import Discussion from 'flarum/models/Discussion';
import escapeRegExp from 'flarum/common/utils/escapeRegExp';
import TagsNav from './components/TagsNav';
import FlagsDropdown from 'flarum/flags/components/FlagsDropdown';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import AvatarNicknameModal from './components/AvatarNicknameModal';
import PayConfirmModal from 'flarum/common/dianLiang/PayConfirmModal';
// import PayConfirmModal from 'flarum/forum/dianLiang/PayConfirmModal';

interface HomepageCountdownHeaderAttrs extends Mithril.Attributes {
  className: string;
  defaultTopImage: string;
  showNavigation?: boolean;
  showCarousel?: boolean;
}

const COUNTDOWN_IMAGE_NAMES = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'mh'];

function renderSkyspireBackdrop() {
  const assetRoot = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}`;

  return (
    <picture className="SkyspirePageBackdrop" aria-hidden="true">
      <img src={`${assetRoot}/tqqxxx_10.png`} alt="" />
    </picture>
  );
}

function renderSkyspireDividerCloud() {
  return (
    <picture className="SkyspireDividerCloud" aria-hidden="true">
      <img className="SkyspireDividerCloud-image" src="https://yjforum.s3.stormsdk.com/dawnboundhero/countdown-yun.png" alt="" />
    </picture>
  );
}

class HomepageCountdownHeader extends Component<HomepageCountdownHeaderAttrs> {
  remainingSeconds = 0;
  countdownTimer?: number;
  countdownImageCache: HTMLImageElement[] = [];

  // 初始化倒计时状态，确保首屏直接选择正确的活动背景。
  oninit(vnode: Mithril.Vnode<HomepageCountdownHeaderAttrs, this>) {
    super.oninit(vnode);
    this.updateRemainingSeconds();

    if (this.remainingSeconds > 0) {
      this.preloadCountdownImages();
    }
  }

  // 挂载后每秒按目标时间戳重新计算，避免定时器累计误差。
  oncreate(vnode: Mithril.VnodeDOM<HomepageCountdownHeaderAttrs, this>) {
    super.oncreate(vnode);

    if (this.remainingSeconds > 0) {
      this.countdownTimer = window.setInterval(() => {
        this.updateRemainingSeconds();
        m.redraw();
      }, 1000);
    }
  }

  // 离开页面时释放定时器，防止重复进入主页后产生多个刷新任务。
  onremove() {
    if (this.countdownTimer !== undefined) {
      window.clearInterval(this.countdownTimer);
    }

    this.countdownImageCache = [];
  }

  // 提前加载并持有全部数字素材，避免数字首次出现时发生加载闪烁。
  preloadCountdownImages() {
    const assetBaseUrl = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}`;

    this.countdownImageCache = COUNTDOWN_IMAGE_NAMES.map((imageName) => {
      const image = new window.Image();
      image.src = `${assetBaseUrl}/countdown-${imageName}.png`;

      if (typeof image.decode === 'function') {
        void image.decode().catch(() => undefined);
      }

      return image;
    });
  }

  // 根据目标时间戳更新剩余秒数，并在归零时停止定时器。
  updateRemainingSeconds() {
    const endTimestamp = Number(app.forum.attribute('gameCountdown'));

    this.remainingSeconds = Math.max(0, Math.ceil((endTimestamp - Date.now()) / 1000));

    if (this.remainingSeconds === 0 && this.countdownTimer !== undefined) {
      window.clearInterval(this.countdownTimer);
      this.countdownTimer = undefined;
    }
  }

  // 使用数字素材渲染 HH:MM:SS，总小时数不折算为天。
  renderCountdown() {
    const totalHours = Math.floor(this.remainingSeconds / 3600);
    const minutes = Math.floor((this.remainingSeconds % 3600) / 60);
    const seconds = this.remainingSeconds % 60;
    const countdownText = `${String(totalHours).padStart(3, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    const assetBaseUrl = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}`;

    return (
      <div className="homepage-countdown__timer" role="timer" aria-label={countdownText}>
        {countdownText.split('').map((character, index) => (
          <img
            key={`countdown-position-${index}`}
            className={character === ':' ? 'homepage-countdown__separator' : 'homepage-countdown__digit'}
            src={`${assetBaseUrl}/countdown-${character === ':' ? 'mh' : character}.png`}
            alt=""
            aria-hidden="true"
          />
        ))}
      </div>
    );
  }

  // 在活动态与常规态之间切换头图、云层和轮播区域。
  view() {
    const countdownActive = this.remainingSeconds > 0;
    const assetBaseUrl = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}`;
    const countdownTopImage = app.data.locale === 'zh-Hant' ? 'countdown-topbg-ft.png' : 'countdown-topbg-en.png';
    const countdownPhoneTopImage = app.data.locale === 'zh-Hant' ? 'countdown-topbg-ft-ph.png' : 'countdown-topbg-en-ph.png';
    const topImage = countdownActive ? countdownTopImage : this.attrs.defaultTopImage;
    const cloudImage = countdownActive ? 'countdown-yun.png' : 'main-yun.png';

    return (
      <div className={`${this.attrs.className}${countdownActive ? ' homepage-countdown--active' : ''}`}>
        {this.attrs.showNavigation && <NavigationBar />}
        {countdownActive ? (
          <div className="homepage-countdown__art">
            <picture className="homepage-countdown__picture">
              <source media="(max-width: 767px)" srcset={`${assetBaseUrl}/${countdownPhoneTopImage}`} />
              <img className="main-img" src={`${assetBaseUrl}/${topImage}`} alt="" />
            </picture>
            {this.renderCountdown()}
            <picture className="homepage-countdown__picture">
              <source media="(max-width: 767px)" srcset={`${assetBaseUrl}/countdown-yun-ph.png`} />
              <img className="main-yun" src={`${assetBaseUrl}/${cloudImage}`} alt="" />
            </picture>
          </div>
        ) : (
          <>
            <img className="main-img" src={`${assetBaseUrl}/${topImage}`} alt="" />
            <img className="main-yun" src={`${assetBaseUrl}/${cloudImage}`} alt="" />
          </>
        )}
        {this.attrs.showCarousel && <HeaderSlideCarousel />}
      </div>
    );
  }
}

export default function () {
  override(RoleBindingModal.prototype, 'onRoleItemClick', function (original, item) {
    const isFirstBind = app.data['currentRole'] === undefined;
    app.modal.show(RoleBindConfirmModal, {
      onConfirm: () => {
        return app
          .request({
            method: 'POST',
            url: app.forum.attribute('apiUrl') + '/userRole',
            body: { srvId: item.srvId, rid: item.rid, pkgId: item.pkgId },
          })
          .then((res) => {
            app.data['currentRole'] = item;
            this.getChargeList ? this.getChargeList() : true;
            return { ...res, firstBind: isFirstBind };
          });
      },
    }, true);
  });

  override(ChangePasswordModal.prototype, 'content', function () {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <p className="helpText">{app.translator.trans('dl-optimization.forum.account_bind_role')}</p>
          <div className="Form-group">
            <Button className="Button Button--primary Button--block" onclick={() => app.modal.close()}>{app.translator.trans('core.forum.change_email.dismiss_button')}</Button>
          </div>
        </div>
      </div>
    );
  });

  override(DiscussionListItem.prototype, 'replyCountItem', function (params) {
    const discussion = this.attrs.discussion;
    const user = discussion.user();
    let posts = discussion.posts();
    const controls = DiscussionControls.controls(discussion, this).toArray();
    return (
      <div className="Dl-DiscussionListItem">
        <div className="Dl-DiscussionListItem-left">
          <span className="DiscussionListItem-tag">{listItems(this.tagItems().toArray())}</span>
        </div>
        <div className="Dl-DiscussionListItem-right">
          <Select value={this.selectVal} options={this.selectOptions} onchange={(e: any) => this.onTranslate(e)} />
          <div className="item">
            <Button className="btn-icon bg-message" aria-label="message"></Button>
            <text>{abbreviateNumber(discussion.replyCount())}</text>
          </div>
          <div className="item">
            <Button className="btn-icon bg-like" aria-label="like"></Button>
            <text>{abbreviateNumber(discussion.firstPost().likesCount())}</text>
          </div>
          {this.controlsView(controls)}
        </div>
      </div>
    );
  });
  override(DiscussionListItem.prototype, 'mainView', function (params): Mithril.Children {
    const discussion = this.attrs.discussion;
    const jumpTo = this.getJumpTo(discussion.firstPost());
    const user = discussion.user();

    // 用户信息的组装时从缓存里面取的 刷新过后就有可能会没掉，这边处理方式从discussion里直接返 level_conf表的id和level需要一致
    let levelConf = user.userLevel().levelConf();
    let firstPost = String(discussion.firstPost() && discussion.firstPost().contentHtml());
    // 使用正则表达式匹配<img>标签
    let imgTagPattern = /<IMG\s[^>]*>/gi;
    // 使用replace方法替换匹配到的<img>标签为【图片】文本
    firstPost = firstPost.replace(imgTagPattern, app.translator.trans('dl-pay.forum.operation.img'));
    let pTagPattern = /<p[^>]*>|<\/p>/gi;
    if (this.highlightRegExp) {
      firstPost = highlight(firstPost, this.highlightRegExp).children;
      let decodedText = firstPost.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
      firstPost = decodedText.replace(pTagPattern, '');
    }
    let isActivity = false;
    let activityStatus = '';

    if (discussion.pkgActivity()) {
      isActivity = true;
      activityStatus = discussion.pkgActivity()?.status();
    }
    let levelImg = undefined;
    let levelImgs;
    let levelImgRes;
    let levelColor;
    let levelColorRes;
    levelImgs = levelConf?.levelImg();
    if (levelImgs) {
      levelImgRes = JSON.parse(levelImgs);
      levelImg = levelImgRes[app.data.pkgLogo.id];
    }
    let levelColors = levelConf?.color();
    if (levelColors) {
      levelColorRes = JSON.parse(levelColors);
      levelColor = levelColorRes[app.data.pkgLogo.id];
    }

    return (
      <Link key={this.contentKey} href={app.route.discussion(discussion, jumpTo)} className="DiscussionListItem-main">
        <div className="DiscussionListItem-texts">
          <div className={`DiscussionListItem-texts-left ${user.isAdmin() ? 'admin' : ''}`}>
            {this.authorAvatarView()}
            <div className="DiscussionListItem-text">
              <div className="DiscussionListItem-userinfo">
                {isActivity && <h2 className="DiscussionListItem-title">[{activityStatus}]</h2>}
                <h2 className="DiscussionListItem-title">{highlight(discussion.title(), this.highlightRegExp)}</h2>
              </div>
              <div className="DiscussionListItem-state">
                <p className="DiscussionListItem-time">{humanTime(discussion.createdAt())}</p>
                <p className="DiscussionListItem-username">{user.nickname()}</p>
              </div>
            </div>
          </div>
        </div>
        <p className="DiscussionListItem-content-text">{firstPost && m.trust(firstPost)}</p>
        {discussion.mainImg() && (
          <div className="DiscussionListItem-content-images">
            <div className="DiscussionListItem-content-image-container">
              <img
                className={`containerImage ${this.lazyLoad ? '' : 'lazy'}`}
                onload={() => {
                  this.lazyLoad = true;
                }}
                loading="lazy"
                src={discussion.mainImg()}
              />
              <img
                className={this.lazyLoad ? 'lazy-img-no' : 'lazy-img'}
                src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/lazy.svg`}
              ></img>
              <button className="containerImageBtn" style="display:none;">
                <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/sector-arrow.png`}></img>
              </button>
            </div>
          </div>
        )}
      </Link>
    );
  });

  PagePage.prototype.centerNavItems = function () {
    const list = app.store.all('centerIconCategories').sort((a, b) => a.sortcount() - b.sortcount());
    const centerOnClick = (event) => {
      //   if (!app.session.user) {
      //     event.preventDefault();
      //     app.modal.show(LogInModal);
      //     return;
      //   }
    };
    if (app.store.models.type != 'phone') {
      return (
        <div className="dl-blocks" id="dl-blocks">
          {list &&
            list.map((category, index) => {
              let url = app.forum.attribute('baseUrl');
              let iconName = category.iconName();
              let localeIconNameFirst = '';
              let localeIconNameSecond = '';
              if (iconName) {
                // 将字符串映射转换为 JavaScript 对象
                const obj = JSON.parse(iconName);
                // 创建 Map 对象并初始化
                const map = new Map(Object.entries(obj));
                const objPc = map.get('pc');
                // 获取特定键的值
                localeIconNameFirst = objPc['first'][app.data.locale];
                localeIconNameSecond = objPc['second'][app.data.locale];
              }
              let iconImg = category.iconImg();
              let localeIconImg = '';
              if (iconImg) {
                // 将字符串映射转换为 JavaScript 对象
                const obj2 = JSON.parse(iconImg);
                // 创建 Map 对象并初始化
                const map2 = new Map(Object.entries(obj2));
                localeIconImg = map2.get('pc');
                if (app.store.models.type == 'phone') {
                  localeIconImg = map2.get('phone');
                }
              }
              return (
                <a
                  href={
                    category.iconLink()
                      ? category.iconLink() && category.iconLink().includes('http')
                        ? category.iconLink()
                        : url + category.iconLink()
                      : '#'
                  }
                  onclick={centerOnClick}
                  icon=""
                >
                  <div className={`dl-block ${app.data.locale == 'zh-Hans' || app.data.locale == 'zh-Hant' ? 'dl-block-zh' : 'dl-block-en'}`}>
                    <img src={localeIconImg} />
                    <p>{localeIconNameFirst}</p>
                  </div>
                </a>
              );
            })}
        </div>
      );
    } else {
      return (
        <div className="dl-blocks" id="dl-blocks">
          {list &&
            list.map((category) => {
              let url = app.forum.attribute('baseUrl');
              let iconName = category.iconName();
              let localeIconName = '';
              if (iconName) {
                // 将字符串映射转换为 JavaScript 对象
                const obj = JSON.parse(iconName);
                // 创建 Map 对象并初始化
                const map = new Map(Object.entries(obj));
                const objPhone = map.get('phone');
                // 获取特定键的值
                localeIconName = objPhone[app.data.locale];
              }
              let iconImg = category.iconImg();
              let localeIconImg = '';
              if (iconImg) {
                // 将字符串映射转换为 JavaScript 对象
                const obj2 = JSON.parse(iconImg);
                // 创建 Map 对象并初始化
                const map2 = new Map(Object.entries(obj2));
                localeIconImg = map2.get('pc');
                if (app.store.models.type == 'phone') {
                  localeIconImg = map2.get('phone');
                }
              }
              return (
                <a
                  href={
                    category.iconLink()
                      ? category.iconLink() && category.iconLink().includes('http')
                        ? category.iconLink()
                        : url + category.iconLink()
                      : '#'
                  }
                  onclick={centerOnClick}
                  icon=""
                >
                  <div className="dl-block">
                    <div className="dl-block-img">
                      <img src={localeIconImg} />
                    </div>
                    <p>{localeIconName}</p>
                  </div>
                </a>
              );
            })}
        </div>
      );
    }
  };
  override(Post.prototype, 'view', function (params) {
    const attrs = this.elementAttrs();

    attrs.className = this.classes(attrs.className as string | undefined).join(' ');

    const controls = PostControls.controls(this.attrs.post, this).toArray();
    const footerItems = this.footerItems().toArray();

    // Same Select safety defaults as above; Select.view() does Object.keys(options).
    const selectOptions = (this as any).selectOptions ?? {};
    const selectVal = (this as any).selectVal ?? '';

    return (
      <article {...attrs}>
        <div key={this.contentKey}>
          {this.loading ? <LoadingIndicator /> : this.content()}
          <aside className="Post-actions Post-actions-lin">
            <ul>
              <div className="Post-actions-left"></div>
              <li className="Post-actions-right">
                <Select value={selectVal} options={selectOptions} onchange={(value: any) => (this as any).onTranslate?.(value)} />
                <div className="Post-actions-operate">{listItems(this.actionItems().toArray())}</div>
                {!!controls.length && (
                  <Dropdown
                    className="Post-controls"
                    buttonClassName="Button Button--icon Button--flat"
                    menuClassName="Dropdown-menu--right"
                    icon="fas fa-ellipsis-h"
                    onshow={() => this.$('.Post-controls').addClass('open')}
                    onhide={() => this.$('.Post-controls').removeClass('open')}
                    accessibleToggleLabel={app.translator.trans('core.forum.post_controls.toggle_dropdown_accessible_label')}
                  >
                    {controls}
                  </Dropdown>
                )}
              </li>
            </ul>
          </aside>
          <footer className="Post-footer">{footerItems.length ? <ul>{listItems(footerItems)}</ul> : null}</footer>
        </div>
      </article>
    );
  });
  extend(Post.prototype, 'view', function (vdom) {
    if (app.cache.trees[this.id].length > 0) {
      vdom.children.push(
        <div className="CommentTree CommentTree-lin" id={this.id}>
          {icon('fas fa-reply')}
          {app.cache.trees[this.id]
            .filter((thing, index, self) => self.findIndex((t) => t.id() === thing.id()) === index)
            .sort((a, b) => {
              return b.createdAt() - a.createdAt();
            })
            .slice(0, 2)
            .map((post) => {
              return CommentPost.component({ post });
            })}
        </div>
      );
    }
    // if (this.attrs.post.replyCount() > app.cache.trees[id].length - app.cache.pushTree[id] || (app.cache.trees[id].length !== 0 && this.attrs.post.replyCount())) {
    if (app.cache.trees[this.id].length > 2) {
      if (app.initializers.has('fof-gamification')) {
        this.include += 'user.ranks,upvotes,';
      }
      if (app.initializers.has('fof/reactions')) {
        this.include += 'reactions';
      }
      vdom.children.push(
        Button.component(
          {
            className: 'Button Button--link Evergreen--show',
            icon: 'fas fa-caret-down',
            // onclick: () => {
            //   app.store.find('trees', id, {include: include.replace(/,\s*$/, "")})
            //     .then(response => {
            //       delete response.payload;
            //       [].push.apply(app.cache.trees[id], app.cache.treesList.slice(app.cache.treesLength,app.cache.treesLength+=10));
            //       // [].push.apply(app.cache.trees[id], response);
            //       m.redraw();
            //     })
            // }
            onclick: () =>
              app.modal.show(CommentModal, {
                id: this.id,
                count: app.cache.trees[this.id].length,
              }),
          },
          app.translator.trans('dl-tree.forum.all_responses', { count: app.cache.trees[this.id].length })
        )
      );
    }
  });
  override(MallPage.prototype, 'view', function (params) {
    return (
      <div className="Mall">
        <div className="Mall-title">{app.translator.trans('dl-pay.forum.user.official_mall')}</div>
        {this.MallUserInfo()}
        {app.data['currentRole'] ? (
          <>
            <div className="Mall-gift-pack-box">{this.MallGiftPack()}</div>
            {this.MallPayBox()}
            <div
              className="pay-btn"
              id="shop-pay-btn"
              onclick={() => {
                this.onClickPayBtn();
              }}
            ></div>
          </>
        ) : (
          <div className="Mall-bind-role-tip">{app.translator.trans('dl-response.forum.mallPage.please_bind_role')}</div>
        )}
      </div>
    );
  });
  override(MallPage.prototype, 'PayBtn', function (params) {
    return <></>;
  });
  override(HeaderView.prototype, 'view', function (params) {
    return <HomepageCountdownHeader className="header-view" defaultTopImage="main-img.png" showNavigation={app.store.models.type == 'phone'} />;
  });
  override(IndexPage.prototype, 'view', function (params) {
    return (
      <div className="IndexPage">
        {this.hero()}
        <div className="container">
          <HeaderSlideCarousel />
          <div className="sideNavContainer">
            <div className="IndexPage-results sideNavOffset">{this.centerTabs()}</div>
          </div>
          <div>
            <DiscussionList state={app.discussions} />
            {this.pushPost()}
          </div>
        </div>
      </div>
    );
  });
  override(HeaderSecondary.prototype, 'items', function (params) {
    const items = new ItemList();

    // items.add('search', <Search state={app.search} />, 30);
    if (app.data.pkgLogo.chatStatus) {
      const imgUrl = JSON.parse(app.data.pkgLogo.chatImage)[app.data.locale];
      const baseImgUrl = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}`;
      const closeImgUrl = `${baseImgUrl}/cbl-lts-people.png`;
      const isChatOpen = ChatRoom.isChatOpen();
      const currentOpenimChat = app.data.currentOpenimChat;
      const chatRoom1Id = (currentOpenimChat && currentOpenimChat.chatRoomGroupId) || '';
      app.session.user &&
        imgUrl &&
        items.add(
          'imlk',
          <div>
            <ChatRoom
              channel="1"
              className={`Button Button--flat chat-entrance ${isChatOpen ? 'ChatRoom-close' : ''}`}
              onclick={
                isChatOpen
                  ? (e: MouseEvent) => {
                    e.stopPropagation();
                    ChatRoom.closeChat();
                  }
                  : undefined
              }
            >
              {/* 同时渲染两张图，通过 display 切换可见性，避免频繁更换 src 导致旧图残留一帧 */}
              <img src={imgUrl} style={isChatOpen ? 'display:none;' : ''}></img>
              <img src={closeImgUrl} style={isChatOpen ? '' : 'display:none;'}></img>
              {isChatOpen && <span className="ChatRoom-close-text">{app.translator.trans('dl-heroTag.forum.return_flarum')}</span>}
              {!isChatOpen && this.getUnreadBadge(chatRoom1Id)}
            </ChatRoom>
          </div>,
          100
        );
    }

    if (app.forum.attribute('showLanguageSelector') && Object.keys(app.data.locales).length > 1) {
      const locales = [];

      for (const locale in app.data.locales) {
        locales.push(
          <Button
            active={app.data.locale === locale}
            icon={app.data.locale === locale ? 'fas fa-check' : true}
            onclick={() => {
              if (app.session.user) {
                app.session.user.savePreferences({ locale }).then(() => window.location.reload());
              } else {
                document.cookie = `locale=${locale}; path=/; expires=Tue, 19 Jan 2038 03:14:07 GMT`;
                window.location.reload();
              }
            }}
          >
            {app.data.locales[locale]}
          </Button>
        );
      }

      items.add(
        'locale controls-item',
        <Dropdown
          buttonClassName="Button Button--flat"
          accessibleToggleLabel={app.translator.trans('core.forum.header.locale_dropdown_accessible_label')}
          icon="fas fa-globe"
          label={app.translator.trans('dl-wiki.forum.locale')}
        >
          {locales}
        </Dropdown>,
        86
      );
    }

    if (app.session.user) {
      items.add('notifications', <NotificationsDropdown state={app.notifications} />, 87);
      if (app.forum.attribute('canViewFlags')) {
        items.add('flags', <FlagsDropdown state={app.flags} />, 87);
      }
      items.add('session', <SessionDropdown />, 0);
    } else {

      // if (app.forum.attribute('allowSignUp')) {
      //   items.add(
      //     'signUp',
      //     <div>
      //       <p>{app.translator.trans('dl-optimization.forum.login_after_textOne')}</p>
      //       <p>{app.translator.trans('dl-optimization.forum.login_after_textTwo')}</p>
      //       <p>{app.translator.trans('dl-optimization.forum.login_after_textThree')}</p>
      //       <p>{app.translator.trans('dl-optimization.forum.login_after_textFour')}</p>
      //       <div>
      //         <span>{app.translator.trans('dl-optimization.forum.right_now_register')}</span><Button className="Button Button--link" onclick={() => app.modal.show(SignUpModal)}>
      //           {app.translator.trans('core.forum.header.sign_up_link')}
      //         </Button>
      //       </div>
      //     </div>,
      //     79
      //   );
      // }

      items.add(
        'logIn',
        <Button className="Button Button--link" icon="fas fa-login" onclick={() => app.modal.show(LogInModal)}>
          {app.translator.trans('core.forum.header.log_in_link')}
        </Button>,
        80
      );
    }

    return items;
  });
  extend(HeaderSecondary.prototype, 'items', function (items) {
    // if (app.store.models.type == 'phone') {
    if (app.session.user) {
      const user = app.session.user!;
      items.remove('session');
      items.add('user-title', <div className="title">{app.translator.trans('dl-heroTag.forum.person')}</div>, 88);
      items.add(
        'profile controls-item',
        <LinkButton icon="fas fa-user" href={app.route.user(user)}>
          {app.translator.trans('core.forum.header.profile_button')}
        </LinkButton>,
        85
      );

      items.add(
        'settings controls-item',
        <LinkButton icon="fas fa-cog" href={app.route('settings')}>
          {app.translator.trans('core.forum.header.settings_button')}
        </LinkButton>,
        50
      );

      if (app.forum.attribute('adminUrl')) {
        items.add(
          'administration controls-item',
          <LinkButton icon="fas fa-wrench" href={app.forum.attribute('adminUrl')} target="_blank">
            {app.translator.trans('core.forum.header.admin_button')}
          </LinkButton>,
          0
        );
      }

      items.add('separator', <Separator />, -90);

      items.add(
        'logOut',
        <Button icon="fas fa-sign-out-alt" onclick={app.session.logout.bind(app.session)}>
          {app.translator.trans('core.forum.header.log_out_button')}
        </Button>,
        -100
      );
    }
    let allPkgLogo = app.data.allPkgLogo.filter((pkgLogo) => {
      return pkgLogo.id != app.data.pkgLogo.id && pkgLogo.status == 1;
    });

    if (allPkgLogo.length > 0 && app.session.user) {
      items.add(
        'multiple-games',
        <div className="multiple-games-box">
          <div className="title">{app.translator.trans('dl-send.forum.other_flarum')}</div>
          <div className="game-list">
            {allPkgLogo.map((item) => {
              const obj = JSON.parse(item.pkgName);
              const map = new Map(Object.entries(obj));
              let localePkgName = map.get(app.data.locale);
              const pkgImage = JSON.parse(item.pkgImage)[app.data.locale];
              let pkgStr = item.pkgStr;
              let origin = window.location.origin;
              let url = origin + '/' + pkgStr;
              let base64Encoded = '';
              if (app.session.user) {
                let md5Map = new Map();
                md5Map.set('pkgId', String(item.id));
                md5Map.set('userName', app.session.user.username());
                md5Map.set('userId', String(app.session.user.uniqueID()));
                md5Map.set('language', app.data.locale);
                md5Map.set('email', app.session.user.email());
                const obj = {};
                for (const [key, value] of md5Map) {
                  obj[key] = value;
                }
                // 将对象转换为字符串
                const mapString = JSON.stringify(obj); // 转换为 JSON 字符串
                base64Encoded = btoa(unescape(encodeURIComponent(mapString)));
              }
              return (
                <div
                  className="game-item"
                  onclick={() => {
                    sessionStorage.removeItem('tagItem');
                    window.location.assign(url);
                  }}
                >
                  <img src={pkgImage}></img>
                </div>
              );
            })}
          </div>
        </div>,
        90
      );
    }

    // }
  });
  //判断当前页面抬头栏需不需要两行
  override(Navigation.prototype, 'view', function (original) {
    const { history, pane } = app;
    // if (app.store.models.type == 'phone') {
    let pkgLogo = app.data.pkgLogo;
    const appNavigation = document.getElementById('app-navigation');
    let isOne = false;
    let isTwo = false;
    let isSearch = true;
    let isWallet = false;
    let isCS = false;
    let feedbackStatus = app.session.user && app.forum.attribute('feedbackStatus');
    let walletStatus = app.session.user && app.forum.attribute('walletStatus');
    const isIOSOrMacOS = /iPad|iPhone|iPod|Macintosh|Mac OS X/i.test(navigator.userAgent);
    const shouldShowWallet = !isIOSOrMacOS || Boolean(app.data['currentRole']);
    let tagPage = false;
    const isSkyspire = m.route.param('tags') === 'skyspire';

    if (app.current.matches(TagView) || app.current.matches(TagViewPC) || app.current.matches(IndexPage) || app.current.matches(WiKiPage)) {
      if (app.store.models.type != 'phone') {
        tagPage = true;
      }
    }
    if (
      app.current.matches(HomePage) ||
      app.current.matches(IndexPage) ||
      app.current.matches(MallPage) ||
      app.current.matches(MallOrderPage) ||
      app.current.matches(TagsPage) ||
      app.current.matches(TagView) ||
      app.current.matches(WiKiPage)
    ) {
      isWallet = true;
    }
    if (
      app.current.matches(HomePage) ||
      app.current.matches(IndexPage) ||
      app.current.matches(TagsPage) ||
      app.current.matches(TagView) ||
      app.current.matches(WiKiPage)
    ) {
      isOne = true;
      appNavigation.className = 'App-navigation';
    } else if (
      app.current.matches(UserPage) ||
      app.current.matches(LikePage) ||
      app.current.matches(SettingPage) ||
      app.current.matches(MentionPage) ||
      app.current.matches(ProfilePagePhone) ||
      app.current.matches(DiscussionPage) ||
      app.current.matches(MallPage) ||
      app.current.matches(MallOrderPage)
    ) {
      appNavigation.className = 'App-navigation';
    } else if (
      app.current.matches(SearchView) ||
      app.current.matches(NotificationsPage) ||
      app.current.matches(FlagsPage) ||
      app.current.matches(CommentsPage) ||
      app.current.matches(LikesPage) ||
      app.current.matches(PayPage)
    ) {
      appNavigation.className = 'App-navigation';
      isSearch = false;
    } else {
      isOne = true;
      isTwo = true;
      appNavigation.className = 'App-navigation-new';
    }

    if (app.store.models.type !== 'phone') {
      isCS = true;
      isWallet = true;
      isSearch = true;
      if (app.current.matches(SearchView)) {
        isSearch = false;
      }
    }

    const user = app.session.user!;
    // 将字符串映射转换为 JavaScript 对象
    const obj = JSON.parse(pkgLogo.pkgName);
    // 创建 Map 对象并初始化
    const map = new Map(Object.entries(obj));
    // 获取特定键的值
    let localePkgName = map.get(app.data.locale);
    // 将字符串映射转换为 JavaScript 对象
    const obj2 = JSON.parse(pkgLogo.pkgLogo);
    // 创建 Map 对象并初始化
    const map2 = new Map(Object.entries(obj2));
    // 获取特定键的值
    let localePkgLogo = map2.get(app.data.locale);
    const currentOpenimChat = app.data.currentOpenimChat;
    const chatRoomId = (currentOpenimChat && currentOpenimChat.groupAdminId) || '';
    return (
      <div>
        <div className="Navigation-box-lin">
          {isOne ? (
            <div
              className={classList('Navigation ButtonGroup', this.attrs.className)}
              onmouseenter={pane && pane.show.bind(pane)}
              onmouseleave={pane && pane.onmouseleave.bind(pane)}
            >
              {this.getDrawerButton()}
              <LinkButton href={app.route('pages.home')} className="Navigation-title">
                <p>{localePkgName}</p>
                <img className="Navigation-img" src={localePkgLogo}></img>
              </LinkButton>
              {feedbackStatus && (
                <Button
                  className="customer-service"
                  aria-label="feedback"
                  onclick={() => {
                    if (!app.session.user) {
                      app.modal.show(LogInModal);
                      return;
                    }
                    let entranceId = app.data.pkgLogo.entranceId;
                    // 打开反馈页面
                    AIHelpSupport.show(entranceId ? entranceId : 'E001');
                  }}
                >
                  <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/btm-keff.png`}></img>
                </Button>
              )}
              {isSearch && <SearchButton />}
              {app.data.pkgLogo.chatStatus == '1' && app.session.user && !app.session.user.isAdmin() && (
                <ChatRoom channel="4" className="customer-service">
                  <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/com-icon-sl.png`}></img>
                  {HeaderSecondary.prototype.getUnreadBadge(chatRoomId, 2)}
                </ChatRoom>
              )}
            </div>
          ) : (
            <div
              className={classList('Navigation ButtonGroup', this.attrs.className)}
              onmouseenter={pane && pane.show.bind(pane)}
              onmouseleave={pane && pane.onmouseleave.bind(pane)}
            >
              {history?.canGoBack() ? [this.getBackButton(), this.getPaneButton()] : this.getDrawerButton()}
              {isCS && (
                <>
                  <LinkButton href={app.route('pages.home')} className="Navigation-title">
                    <p>{localePkgName}</p>
                    <img className="Navigation-img" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/logo.png`}></img>
                  </LinkButton>
                </>
              )}
            </div>
          )}
          {!isOne && isCS && <div>{app.current.matches(SearchView) && SearchView.prototype.title()}</div>}
          <div className="Navigation-right-lin">
            {isWallet && walletStatus && shouldShowWallet ? (
              <a
                onclick={(event) => {
                  event.stopPropagation();
                  if (!app.session.user) {
                    event.preventDefault();
                    app.modal.show(LogInModal);
                    return;
                  }
                }}
                href={app.route('pay', { type: 'postPayed' })}
                className="my-wallet-btn"
              >
                <div className="btn">
                  <a>
                    <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-qianbao.png`}></img>
                  </a>
                </div>
                <div className="money">${app.store.balance ? app.store.balance : '0'}</div>
              </a>
            ) : (
              <></>
            )}
            {app.session.user && isWallet && <LinkButton href={app.route.user(app.session.user)}>{avatar(app.session.user)}</LinkButton>}
          </div>
          {!isSkyspire && <FloatPromptButton />}
        </div>
        {isTwo && (
          <div className="Navigation-next">
            <div
              className={classList('Navigation ButtonGroup', this.attrs.className)}
              onmouseenter={pane && pane.show.bind(pane)}
              onmouseleave={pane && pane.onmouseleave.bind(pane)}
            >
              {history?.canGoBack() ? [this.getBackButton(), this.getPaneButton()] : null}
            </div>
            {/* <PostButton /> */}
          </div>
        )}
        {tagPage && <TagsNav />}
        {app.session.user && FloatingNotificationBanner()}
      </div>
    );
  });
  override(ComposerBody.prototype, 'view', function (original) {
    return (
      <ConfirmDocumentUnload when={this.hasChanges.bind(this)}>
        <div className={classList('ComposerBody', this.attrs.className)}>
          <div className={`ComposerBody-top ${this.attrs.user.isAdmin() ? 'admin' : ''}`}>
            {avatar(this.attrs.user, { className: 'ComposerBody-top-avatar' })}
            <div className="ComposerBody-top-name">{this.attrs.user.nickname()}</div>
          </div>
          <div className="ComposerBody-content">
            <ul className="ComposerBody-header">{listItems(this.headerItems().toArray())}</ul>
            <img className="ComposerBody-line" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-fgex.png`}></img>
            <div className="ComposerBody-editor">
              <TextEditor
                submitLabel={this.attrs.submitLabel}
                placeholder={this.attrs.placeholder}
                disabled={this.loading || this.attrs.disabled}
                composer={this.composer}
                preview={this.jumpToPreview?.bind(this)}
                onchange={this.composer.fields.content}
                onsubmit={this.onsubmit.bind(this)}
                value={this.composer.fields.content()}
              />
            </div>
            <ul className="ComposerBody-footer">{listItems(this.footItems().toArray())}</ul>
          </div>
          <LoadingIndicator display="unset" containerClassName={classList('ComposerBody-loading', this.loading && 'active')} size="large" />
        </div>
      </ConfirmDocumentUnload>
    );
  });
  extend(TextEditor.prototype, 'oninit', function (original) {
    this.activityTag = Stream(0);
    this.activityTitle = Stream(app.translator.trans('dl-response.forum.discussion.activity'));
    this.titleSlug = Stream('');
    this.adtivityId = Stream(0);
  });
  if (app.store.models.type != 'phone') {
    override(TextEditor.prototype, 'view', function (original) {
      // if (app.store.models.type == 'phone') {
      let pkgActivityMap = [];
      pkgActivityMap.push({ id: 0 });
      app.store.all('pkgActivityCategories').filter((pkgActivity) => {
        if (pkgActivity.isLoading() && pkgActivity.type() == 0) {
          pkgActivityMap = pkgActivityMap.concat(...pkgActivity.activityTag());
        }
      });
      return (
        <div className="TextEditor">
          <div className="TextEditor-editorContainer" id="imageContainer"></div>
          {this.activityTag() != 0 && (
            <div className="TextEditor-activity">
              <div className="TextEditor-activity-item">
                <div className="TextEditor-activity-item-title">{this.activityTitle()}</div>
                <Button
                  className="TextEditor-activity-item-close"
                  onclick={() => {
                    this.activityTag(0);
                    this.activityTitle(app.translator.trans('dl-response.forum.discussion.activity'));
                    this.titleSlug('');
                    this.attrs.composer.fields.tags = [];
                  }}
                >
                  <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/ft-hd-qx.png`}></img>
                </Button>
              </div>
            </div>
          )}
          <div className="TextEditor-operation">
            <ul className="TextEditor-controls Composer-footer">
              {listItems(this.controlItems().toArray())}
              <li className="TextEditor-toolbar">{this.toolbarItems().toArray()}</li>
              <li>
                <div className={'activity ' + (this.activityTag() != 0 ? 'activity-check' : '')}>
                  <Dropdown
                    buttonClassName="Button"
                    // label={sortOptions[app.search.params().sort] || Object.keys(sortMap).map((key) => sortOptions[key])[0]}
                    label={this.activityTitle()}
                    accessibleToggleLabel={app.translator.trans('core.forum.index_sort.toggle_dropdown_accessible_label')}
                  >
                    {pkgActivityMap.map((category, key) => {
                      // let value = new Map();
                      // value.set('0', category.id());
                      let tagsObj = [];
                      if (key !== 0) {
                        let activityTag = category;
                        tagsObj.push({
                          id: activityTag.id(),
                          name: activityTag.name(),
                          tag: activityTag.tagObj(),
                          description: activityTag.description(),
                        });
                      } else {
                        tagsObj.push({ id: 0, name: app.translator.trans('dl-discussionComposer.forum.unSelect'), tag: 0, description: '' });
                      }

                      return tagsObj.map((category2) => {
                        let localDescription = '';
                        let name = category2?.name;
                        let localeName = category2?.name;
                        let description = category2?.description;
                        if (name && category2.id != 0) {
                          // 将字符串映射转换为 JavaScript 对象
                          const obj = JSON.parse(name);
                          // 创建 Map 对象并初始化
                          const map = new Map(Object.entries(obj));
                          // 获取特定键的值
                          localeName = map.get(app.data.locale);
                          // tagList.set(category2?.id, localeName);
                        }
                        if (description) {
                          const obj2 = JSON.parse(description);
                          const map2 = new Map(Object.entries(obj2));
                          localDescription = map2.get(app.data.locale);
                        }

                        return (
                          <Button
                            className="activity-btn"
                            onclick={() => {
                              if (category2.id != 0 && !app.data['currentRole']) {
                                app.modal.show(RouteToBindRoleModal, {
                                  text: app.translator.trans('dl-response.forum.warn.no_binding_role'),
                                  promise: true,
                                  onconfirm: (resolve, reject) => {
                                    app.modal.show(RoleBindingModal);
                                    // let url = app.forum.attribute('baseUrl');
                                    // window.open(url + '/u/' + app.session.user.username(), "_blank");
                                    // app.route.user(app.session.user);
                                  },
                                });
                                return;
                              }
                              this.adtivityId(0);
                              this.activityTag(0);
                              this.activityTitle(app.translator.trans('dl-response.forum.discussion.activity'));
                              this.titleSlug('');
                              this.attrs.composer.fields.tags = [];

                              // this.activityTag(jsonString)
                              // if (category2.id == 0) return
                              if (category2.id != 0) {
                                this.adtivityId(category.id());
                                this.activityTag(category2.id);
                                this.activityTitle(localeName);
                                this.titleSlug(`【${localeName}】`);
                                if (category2.tag) {
                                  this.attrs.composer.fields.tags = [category2.tag];
                                } else {
                                  this.attrs.composer.fields.tags = [];
                                }
                              }
                            }}
                          >
                            <div className="activity-title">{localeName}</div>
                            <div className="activity-content">{localDescription}</div>
                          </Button>
                        );
                      });
                    })}
                  </Dropdown>
                </div>
              </li>
            </ul>
            <Button className="TextEditor-submit-btn" onclick={this.onsubmit.bind(this)}>
              {app.translator.trans('dl-pay.forum.operation.post')}
            </Button>
          </div>
        </div>
      );
      // } else {
      //   return original();
      // }
    });
  }
  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    items.add(
      'mention',
      <TextEditorButton onclick={() => this.attrs.composer.editor.insertAtCursor('@admin ')} icon="fas fat-at">
        {app.translator.trans('dl-response.forum.mention_admin')}
      </TextEditorButton>
    );
  });
  if (app.store.models.type != 'phone') {
    override(DiscussionComposer.prototype, 'footItems', function (original) {
      const items = new ItemList();
      items.add('uploadFile', <UploadFileButton uploader={this.uploader} onchange={this.mainImg} />);
      return items;
    });
  }
  if (app.store.models.type == 'phone') {
    override(DiscussionComposer.prototype, 'footItems', function (original) {
      const items = new ItemList();
      items.add('uploadFile', <UploadFileButton uploader={this.uploader} onchange={this.mainImg} />, 100);
      // let tagMap = app.store.all('tags').filter((tag) => !tag.isAllTag() && tag.pkgId() == app.data.pkgLogo.id);
      let pkgActivityMap = [];
      pkgActivityMap.push({ id: 0 });
      app.store.all('pkgActivityCategories').filter((pkgActivity) => {
        if (pkgActivity.isLoading() && pkgActivity.type() == 0) {
          pkgActivityMap = pkgActivityMap.concat(...pkgActivity.activityTag());
        }
      });
      items.add(
        'activity',
        <div className={'activityList'}>
          {this.activityTag() != 0 && (
            <div className="TextEditor-activity">
              <div className="TextEditor-activity-item">
                <div className="TextEditor-activity-item-title">{this.activityTitle()}</div>
                <Button
                  className="TextEditor-activity-item-close"
                  onclick={() => {
                    this.activityTag(0);
                    this.activityTitle(app.translator.trans('dl-response.forum.discussion.activity'));
                    this.titleSlug('');
                    this.attrs.composer.fields.tags = [];
                  }}
                >
                  <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/ft-hd-qx.png`}></img>
                </Button>
              </div>
            </div>
          )}
        </div>,
        10
      );

      items.add(
        'tagLists',
        <div className={'activity ' + (this.activityTag() != 0 ? 'activity-check' : '')} style={this.activityTag() != 0 ? { display: 'none' } : {}}>
          <Dropdown
            buttonClassName="Button"
            // label={sortOptions[app.search.params().sort] || Object.keys(sortMap).map((key) => sortOptions[key])[0]}
            label={this.activityTitle()}
            accessibleToggleLabel={app.translator.trans('core.forum.index_sort.toggle_dropdown_accessible_label')}
          >
            {pkgActivityMap.map((category, key) => {
              // let value = new Map();
              // value.set('0', category.id());
              let tagsObj = [];
              if (key !== 0) {
                tagsObj.push({ id: category.id(), name: category.name(), tag: category.tagObj(), description: category.description() });
              } else {
                tagsObj.push({ id: 0, name: app.translator.trans('dl-discussionComposer.forum.unSelect'), tag: 0, description: '' });
              }

              return tagsObj.map((category2) => {
                let localDescription = '';
                let name = category2?.name;
                let localeName = category2?.name;
                let description = category2?.description;
                if (name && category2.id != 0) {
                  // 将字符串映射转换为 JavaScript 对象
                  const obj = JSON.parse(name);
                  // 创建 Map 对象并初始化
                  const map = new Map(Object.entries(obj));
                  // 获取特定键的值
                  localeName = map.get(app.data.locale);
                  // tagList.set(category2?.id, localeName);
                }
                if (description) {
                  const obj2 = JSON.parse(description);
                  const map2 = new Map(Object.entries(obj2));
                  localDescription = map2.get(app.data.locale);
                }

                return (
                  <Button
                    className="activity-btn"
                    onclick={() => {
                      // if (category2.id != 0 && !app.data['currentRole']) {
                      //   app.modal.show(RouteToBindRoleModal, {
                      //     text: app.translator.trans('dl-response.forum.warn.no_binding_role'),
                      //     promise: true,
                      //     onconfirm: (resolve, reject) => {
                      //       app.modal.show(RoleBindingModal);
                      //       // let url = app.forum.attribute('baseUrl');
                      //       // window.open(url + '/u/' + app.session.user.username(), "_blank");
                      //       // app.route.user(app.session.user);
                      //     },
                      //   });
                      //   return;
                      // }
                      this.adtivityId(0);
                      this.activityTag(0);
                      this.activityTitle(app.translator.trans('dl-response.forum.discussion.activity'));
                      this.titleSlug('');
                      this.composer.fields.tags = [];

                      // this.activityTag(jsonString)
                      // if (category2.id == 0) return
                      if (category2.id != 0) {
                        this.adtivityId(category.id());
                        this.activityTag(category2.id);
                        this.activityTitle(localeName);
                        this.titleSlug(`【${localeName}】`);
                        if (category2.tag) {
                          this.composer.fields.tags = [category2.tag];
                        } else {
                          this.composer.fields.tags = [];
                        }
                      }
                    }}
                  >
                    <div className="activity-title">{localeName}</div>
                    <div className="activity-content">{localDescription}</div>
                  </Button>
                );
              });
            })}
          </Dropdown>
        </div>,
        5
      );

      return items;
      // }
    });
  }
  override(CommentPost.prototype, 'content', function (original) {
    try {
      original();
    } catch (e) {
      // 防御性：即便老实现有异常，也不要影响自定义渲染
      console.error(e);
    }

    const post = this.attrs.post;
    const discussions = post.discussion();
    const tagItem = discussions.tags();

    const contentHtml = post.contentHtml();
    this.refreshContent();

    const isContentTooLong = this.calculateLineCount(contentHtml);
    let atUser = '';
    if (post.replyTo() != 0 && post.replyPost() != 0 && post.replyPost() != null) {
      if (post.replyToPost()) {
        atUser = '@' + post.replyToPost().user().nickname();
      }
    }
    const formatted = this.formatContent(this.contentHtml);
    let isWikiHeroNewData = false;
    let heroTagLatestdata = null;
    let heroTagHeroIntro = null;

    if (app.cache.heroTagLatestdata) {
      isWikiHeroNewData =
        post.number() === 1 && app.cache.heroTagLatestdata && discussions.id() == tagItem[0].wikiHeroDetailDiscussionId();
      heroTagLatestdata = app.cache.heroTagLatestdata;
      heroTagHeroIntro = app.cache.heroTagLatestdata.heroTagHeroIntro();
    } else if (post.number() === 1) {
      heroTagLatestdata = tagItem[0] && tagItem[0].heroTagLatestdata();
      isWikiHeroNewData = post.number() === 1 && !!heroTagLatestdata && discussions.id() == tagItem[0].wikiHeroDetailDiscussionId();
      heroTagHeroIntro = heroTagLatestdata && tagItem[0].heroTagLatestdata().heroTagHeroIntro();
    }

    const flags = post.flags ? post.flags() : [];
    const flaggedView =
      (app.forum.attribute('adminUrl')) && flags && flags.length
        ? (
          <div className="Post-flagged">
            <div className="Post-flagged-flags">
              {flags.map((flag) => (
                <div className="Post-flagged-flag">{this.flagReason(flag)}</div>
              ))}
            </div>
            <div className="Post-flagged-actions">{this.flagActionItems().toArray()}</div>
          </div>
        )
        : null;

    return [
      <div className={`Post-box ${isWikiHeroNewData ? 'iswikihero' : ''}`}>
        {flaggedView}
        <header className="Post-header Post-header-lin">
          <ul>{listItems(this.headerItems().toArray())}</ul>
        </header>
        <span className="Post-body Post-body-lin">
          {post.number() == 1 && (
            <p>
              {this.isActivity && <span>[{this.activityStatus}]</span>}
              <span>{this.title}</span>
            </p>
          )}
          {this.isEditing() ? (
            <ComposerPostPreview className="Post-preview" composer={app.composer} />
          ) : atUser ? (
            m.trust('<span class="at-user-reference">' + atUser + '</span><br/>' + formatted)
          ) : (
            m.trust(formatted)
          )}
        </span>
        {isWikiHeroNewData && (
          <div className="Post-body-wikihero">
            <div className="Post-body-wikihero-bg1">
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/wikihero-bg1.png`} alt="" />
            </div>
            <div className="Post-body-wikihero-bg2">
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/wikihero-bg3.jpg`} alt="" />
            </div>
            <div className="Post-body-wikihero-img">
              <img src={this.normalizeJson(heroTagLatestdata?.mainImage())} />
            </div>
            <div className="Post-body-wikihero-skill">
              {heroTagHeroIntro
                .sort((a, b) => a.sort() - b.sort())
                .map((item, index) => {
                  return (
                    <div className="skill-item">
                      <div className="skill-item-number">
                        <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/wikihero-skill${index + 1}.png`}></img>
                      </div>
                      <div className="skill-item-content">
                        <div className="skill-header">
                          <div className="skill-img">
                            <img src={item?.skillImg()}></img>
                          </div>
                          <div className="skill-info">
                            <div className="skill-info-title">
                              <div className="skill-info-name">{this.normalizeJson(item.skillName())}</div>
                              <div className="skill-info-positioning">
                                {this.normalizeJson(item.skillEffect()).map((item2) => {
                                  return <span>{item2}</span>;
                                })}
                              </div>
                            </div>
                            <div className="skill-info-type">
                              <span>{app.translator.trans('dl-heroTag.forum.skill_type')}：</span>
                              <span>{this.normalizeJson(item.skillType())}</span>
                            </div>
                            <div className="skill-info-description">
                              <span>{this.normalizeJson(item.skillIntro())}</span>
                            </div>
                          </div>
                        </div>
                        <div className="skill-footer">
                          {item
                            .heroTagHeroLevel()
                            .sort((a, b) => a.level() - b.level())
                            .map((item2) => {
                              return (
                                <div className="skill-footer-item">
                                  <span className="skill-footer-item-level">{'Lv.' + item2.level()}</span>
                                  <span className="skill-footer-item-description">{this.normalizeJson(item2.introduction())}</span>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="Post-body-wikihero-story">
              <div className="Post-body-wikihero-story-img">
                <img src={heroTagLatestdata?.storyImg()} />
              </div>
              <div className="Post-body-wikihero-story-content">{m.trust(heroTagLatestdata?.storyContent())}</div>
            </div>
          </div>
        )}
      </div>,
    ];
  });
  override(PostUser.prototype, 'view', function (original) {
    // if (app.store.models.type == 'phone') {
    const post = this.attrs.post;
    const discussion = this.attrs.discussion;
    let user = post.user();
    let userId = user.id();
    let userLevel = user?.userLevel();
    let levelImg = undefined;
    let levelColor;
    let levelImgs;
    let levelImgRes;
    let levelColors;
    let levelColorRes;
    if (userLevel) {
      levelImgs = userLevel?.levelConf()?.levelImg();
      if (levelImgs) {
        levelImgRes = JSON.parse(levelImgs);
        levelImg = levelImgRes[app.data.pkgLogo.id];
      }
      levelColors = userLevel.levelConf().color();
      if (levelColors) {
        levelColorRes = JSON.parse(levelColors);
        levelColor = levelColorRes[app.data.pkgLogo.id];
      }
    } else {
      try {
        levelImgs = user.data.attributes.levelConf.level_img;
        if (levelImgs) {
          levelImgRes = JSON.parse(levelImgs);
          levelImg = levelImgRes[app.data.pkgLogo.id];
        }
        levelColors = user.data.attributes.levelConf.color;
        if (levelColors) {
          levelColorRes = JSON.parse(levelColors);
          levelColor = levelColorRes[app.data.pkgLogo.id];
        }
      } catch (e) {
        console.log(e);
      }
    }

    if (!user) {
      return (
        <div className="PostUser">
          <h3 className="PostUser-name">
            {avatar(user, { className: 'PostUser-avatar' })} {username(user)}
          </h3>
        </div>
      );
    }

    // 收藏
    let subscription = discussion?.subscription();
    let buttonClass = 'SubscriptionMenu-button--' + subscription;
    buttonClass = 'SubscriptionMenu-button--null';
    let buttonIcon = 'fas fa-star';

    let isWikiHeroNewData = false;
    const discussions = this.attrs.post.discussion();
    const tagItem = discussions.tags();
    if (app.cache.heroTagLatestdata) {
      isWikiHeroNewData =
        this.attrs.post.number() === 1 && app.cache.heroTagLatestdata && discussions.id() == tagItem[0].wikiHeroDetailDiscussionId();
    } else if (this.attrs.post.number() === 1) {
      isWikiHeroNewData =
        this.attrs.post.number() === 1 && tagItem[0] && tagItem[0].heroTagLatestdata() && discussions.id() == tagItem[0].wikiHeroDetailDiscussionId();
    }
    return isWikiHeroNewData ? (
      <div className="DiscussionListItem-tag ishero">
        <Button
          className={'collection-btn ' + (subscription ? 'collection-btn-follow-bg' : 'collection-btn-null-bg')}
          aria-label="collection"
          onclick={(e) => {
            if (!app.session.user) {
              app.modal.show(LogInModal);
              return;
            }
            subscription = ['follow', 'ignore'].indexOf(subscription) == -1 ? 'follow' : null;
            discussion.save({ subscription });
            document.getElementsByClassName('collection-btn')[0].className =
              'collection-btn ' + (subscription ? 'collection-btn-follow-bg' : 'collection-btn-null-bg');
            // TODO
          }}
        ></Button>
      </div>
    ) : (
      <div className="PostUser">
        <h3 className="PostUser-name ">
          <div className={`DiscussionListItem-texts ${user.isAdmin() ? 'admin' : ''}`}>
            <Link
              href={app.route.user(user)}
              onclick={(event) => {
                if (!app.session.user) {
                  event.preventDefault();
                  app.modal.show(LogInModal);
                  return;
                }
              }}
            >
              {avatar(user, { className: 'PostUser-avatar' })}
            </Link>
            <div className="DiscussionListItem-box-lin">
              <div className="DiscussionListItem-text DiscussionListItem-text-lin">
                <div className='DiscussionListItem-username-wrap'>
                  <a
                    href={app.route.user(user)}
                    className="DiscussionListItem-username"
                    onclick={(event) => {
                      if (!app.session.user) {
                        event.preventDefault();
                        app.modal.show(LogInModal);
                        return;
                      }
                    }}
                  >
                    {nickname(user)}
                  </a>
                  <div className="DiscussionListItem-img-box">
                    <img className="DiscussionListItem-img" src={levelImg} />
                    <span
                      className="DiscussionListItem-img-lv"
                      style={`text-shadow: -1px 0 0 ${levelColor}, 0 -1px 0 ${levelColor},-1px -1px 0 ${levelColor}, 1px -1px 0 ${levelColor}, -1px 1px 0 ${levelColor}, 1px 1px 0 ${levelColor};`}
                    >
                      {`Lv.${user?.userLevel()?.levelConf()?.level()}`}
                    </span>
                  </div>
                </div>
                <p className="DiscussionListItem-time">{humanTime(post.createdAt())}</p>
                {post.number() == 1 && (
                  <div className="DiscussionListItem-tag">
                    <Button
                      className={'collection-btn ' + (subscription ? 'collection-btn-follow-bg' : 'collection-btn-null-bg')}
                      aria-label="collection"
                      onclick={(e) => {
                        if (!app.session.user) {
                          app.modal.show(LogInModal);
                          return;
                        }
                        subscription = ['follow', 'ignore'].indexOf(subscription) == -1 ? 'follow' : null;
                        discussion.save({ subscription });
                        document.getElementsByClassName('collection-btn')[0].className =
                          'collection-btn ' + (subscription ? 'collection-btn-follow-bg' : 'collection-btn-null-bg');
                        // TODO
                      }}
                    ></Button>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* {userOnline(user)} */}
        </h3>

        {/* {!post.isHidden() && this.attrs.cardVisible && (
          <UserCard user={user} className="UserCard--popover" controlsButtonClassName="Button Button--icon Button--flat" />
        )} */}
      </div>
    );
    // } else {
    //   return original();
    // }
  });
  extend(TagViewPC.prototype, 'oninit', function (original) {
    this.activeTab = 1;
    this.discussionId = null;
    this.discussion = null;
    this.wikiStream = null;
    if (!app.cache.activeTabTag) {
      app.cache.activeTabTag = 1;
    }
    if (!app.cache.activeTab && this.attrs.type) {
      app.cache.activeTab = Number(this.attrs.type);
    }
  });
  extend(TagViewPC.prototype, 'oncreate', function (original) {
    this.activeTab = app.cache.activeTabTag;
  });
  override(TagViewPC.prototype, 'view', function (original) {
    let url = app.forum.attribute('baseUrl');
    const centerOnClick = (event) => {
      //   if (!app.session.user) {
      //     event.preventDefault();
      //     app.modal.show(LogInModal);
      //     return;
      //   }
    };
    const multilingual = (name) => {
      if (!name) return '';
      let data = JSON.parse(name);
      return data[app.data.locale];
    };
    let isWikiHero = this.tagItem[0] && this.tagItem[0].isWikiHero() == 1;
    const ftbtn = document.getElementsByClassName('floatingImageContainer')[0];
    isWikiHero && ftbtn && ftbtn.style && (this.activeTab === 1 ? (ftbtn.style.display = 'none') : (ftbtn.style.display = 'block'));
    app.cache.heroTagLatestdata = null;
    if (this.tagItem[0] && this.tagItem[0].wikiHeroDetailDiscussionId() && this.discussionId === null) {
      this.discussionId = this.tagItem[0].wikiHeroDetailDiscussionId();
      app.store.find<Discussion>('discussions', this.discussionId).then((val) => {
        this.discussion = val;
        this.wikiStream = new PostStreamState(this.discussion, [], 0);
        m.redraw();
      });
      app.cache.heroTagLatestdata = this.tagItem[0].heroTagLatestdata();
    }
    return this.tagItem[0] ? (
      this.tagItem[0].isNotBasic() == 1 ? (
        <WiKiPage tags={this.attrs.tags} routeName="tag" />
      ) : (
        <main class="App-content">
          <div id="content">
            <div className="TagsPage">
              {this.attrs.tags === 'skyspire' && renderSkyspireBackdrop()}
              <div className="dl-content">
                <div className={`dl_tag_image image-placeholder ${isWikiHero ? 'wiki-hero' : ''}`}>
                  {this.tagItem.length > 0 && (
                    <a
                      href={
                        this.tagItem[0].mainImgJumpUrl()
                          ? this.tagItem[0].mainImgJumpUrl() &&
                          (this.tagItem[0].mainImgJumpUrl().includes('http')
                            ? this.tagItem[0].mainImgJumpUrl()
                            : url + this.tagItem[0].mainImgJumpUrl())
                          : '#'
                      }
                      onclick={centerOnClick}
                    >
                      {isWikiHero && (
                        <img
                          class="wiki-hero-bg"
                          src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/wiki-banner2.png`}
                          onload={function () {
                            this.classList.remove('lazy');
                            this.classList.add('lazy-loaded');
                          }}
                        />
                      )}
                      <img
                        class="carousel__slide-image"
                        src={this.localeMainImgUrl}
                        onload={function () {
                          this.classList.remove('lazy');
                          this.classList.add('lazy-loaded');
                        }}
                      />
                      {isWikiHero && (
                        <div className="wiki-hero-info">
                          <div className="wiki-hero-title">
                            <p className="wiki-hero-title-nickname">{multilingual(this.tagItem[0].mainHeroNickname())}</p>
                            <p className="wiki-hero-title-name">{multilingual(this.tagItem[0].mainHeroName())}</p>
                          </div>
                          <div className="wiki-hero-content">
                            <span className="wiki-hero-content-discussion">
                              {app.translator.trans('dl-wiki.forum.post_num')}：{this.tagItem[0].discussionCount()}
                            </span>
                            <span className="wiki-hero-content-views">
                              {app.translator.trans('dl-wiki.forum.view_num')}：{this.tagItem[0].viewsCount()}
                            </span>
                          </div>
                        </div>
                      )}
                    </a>
                  )}
                  <div class="separator"></div>
                  {this.attrs.tags === 'skyspire' && renderSkyspireDividerCloud()}
                </div>
                {this.attrs.tags === 'skyspire' ? (
                  <SkyspirePage tagId={this.tagItem?.[0]?.id()} />
                ) : (
                  <div className="IndexPage-toolbar-box">
                  {isWikiHero && (
                    <div className="wiki-tab-header">
                      <button
                        className={`wiki-tab-btn ${this.activeTab === 1 ? 'active' : ''}`}
                        onclick={() => {
                          this.activeTab = 1;
                          app.cache.activeTabTag = 1;
                          m.redraw();
                        }}
                      >
                        <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/wiki-btnicon4.png`} />
                        <span>{app.translator.trans('dl-wiki.forum.latest_data')}</span>
                      </button>
                      <button
                        className={`wiki-tab-btn ${this.activeTab === 2 ? 'active' : ''}`}
                        onclick={() => {
                          this.activeTab = 2;
                          app.cache.activeTabTag = 2;
                          m.redraw();
                        }}
                      >
                        <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/wiki-btnicon5.png`} />
                        <span>{app.translator.trans('dl-wiki.forum.posted_by_players')}</span>
                      </button>
                    </div>
                  )}
                  {this.activeTab === 1 && isWikiHero ? (
                    this.discussion ? (
                      <div className="IndexPage-toolbar dl-discussion-container">
                        <div className="DiscussionPage-stream">
                          <PostStream discussion={this.discussion} stream={this.wikiStream} onPositionChange={() => { }} unLoadNext={true} />
                        </div>
                        <LinkButton className="TagView-load-more" href={app.route.discussion(this.discussion, 0)}>
                          {app.translator.trans('dl_discussion.forum.loading_more') + '>>>'}
                        </LinkButton>
                      </div>
                    ) : (
                      <></>
                    )
                  ) : (
                    // <DiscussionPage id={this.discussionId} />
                    <div className="IndexPage-toolbar dl-discussion-container">
                      <div className="IndexPage-toolbar-lin">
                        <ul className="IndexPage-toolbar-view">{listItems(IndexPage.prototype.viewItems().toArray())}</ul>
                        <ul className="IndexPage-toolbar-action">{listItems(IndexPage.prototype.actionItems().toArray())}</ul>
                      </div>
                      <DiscussionList state={app.discussions} isAllTag={this.tagItem.length > 0 && this.tagItem[0].isAllTag()} />
                    </div>
                  )}
                  </div>
                )}
              </div>
            </div>
          </div>
          {this.attrs.tags !== 'skyspire' && !app.session.user?.isSuspended() && this.tagItem.length > 0 && this.tagItem[0].canStartDiscussion() && (
            <FloatPostButton />
          )}
        </main>
      )
    ) : (
      <main class="App-content" style="min-height: 100vh">
        {/* {this.title()} */}
      </main>
    );
  });
  extend(TagView.prototype, 'oninit', function (original) {
    this.activeTab = 1;
    this.discussionId = null;
    this.discussion = null;
    this.wikiStream = null;
    if (!app.cache.activeTabTag) {
      app.cache.activeTabTag = 1;
    }
    if (!app.cache.activeTab && this.attrs.type) {
      app.cache.activeTab = Number(this.attrs.type);
    }
  });
  extend(TagView.prototype, 'oncreate', function (original) {
    this.activeTab = app.cache.activeTabTag;
  });
  override(TagView.prototype, 'view', function (original) {
    let url = app.forum.attribute('baseUrl');
    const centerOnClick = (event) => {
      //   if (!app.session.user) {
      //     event.preventDefault();
      //     app.modal.show(LogInModal);
      //     return;
      //   }
    };
    const multilingual = (name) => {
      if (!name) return '';
      let data = JSON.parse(name);
      return data[app.data.locale];
    };
    let isWikiHero = this.tagItem[0] && this.tagItem[0].isWikiHero() == 1;
    const ftbtn = document.getElementsByClassName('floatingImageContainer')[0];
    isWikiHero && ftbtn && ftbtn.style && (this.activeTab === 1 ? (ftbtn.style.display = 'none') : (ftbtn.style.display = 'block'));
    app.cache.heroTagLatestdata = null;
    if (this.tagItem[0] && this.tagItem[0].wikiHeroDetailDiscussionId() && this.discussionId === null) {
      this.discussionId = this.tagItem[0].wikiHeroDetailDiscussionId();
      app.store.find<Discussion>('discussions', this.discussionId).then((val) => {
        this.discussion = val;
        this.wikiStream = new PostStreamState(this.discussion, [], 0);
        m.redraw();
      });
      app.cache.heroTagLatestdata = this.tagItem[0].heroTagLatestdata();
    }
    return this.tagItem[0] ? (
      this.tagItem[0].isNotBasic() == 1 ? (
        <WiKiPage tags={this.attrs.tags} routeName="tag" />
      ) : (
        <main class="App-content">
          {this.title()}
          <div id="content">
            <div className="TagsPage">
              {this.attrs.tags === 'skyspire' && renderSkyspireBackdrop()}
              <div className="dl-content">
                <div className={`dl_tag_image image-placeholder ${isWikiHero ? 'wiki-hero' : ''}`}>
                  {this.tagItem.length > 0 && (
                    <a
                      href={
                        this.tagItem[0].mainImgJumpUrl()
                          ? this.tagItem[0].mainImgJumpUrl() &&
                          (this.tagItem[0].mainImgJumpUrl().includes('http')
                            ? this.tagItem[0].mainImgJumpUrl()
                            : url + this.tagItem[0].mainImgJumpUrl())
                          : '#'
                      }
                      onclick={centerOnClick}
                    >
                      {isWikiHero && (
                        <img
                          class="wiki-hero-bg"
                          src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/wiki-banner2-ph.png`}
                          onload={function () {
                            this.classList.remove('lazy');
                            this.classList.add('lazy-loaded');
                          }}
                        />
                      )}
                      <img
                        class="carousel__slide-image"
                        src={this.localeMainImgUrl}
                        onload={function () {
                          this.classList.remove('lazy');
                          this.classList.add('lazy-loaded');
                        }}
                      />
                      {isWikiHero && (
                        <div className="wiki-hero-info">
                          <div className="wiki-hero-title">
                            <p className="wiki-hero-title-nickname">{multilingual(this.tagItem[0].mainHeroNickname())}</p>
                            <p className="wiki-hero-title-name">{multilingual(this.tagItem[0].mainHeroName())}</p>
                          </div>
                          <div className="wiki-hero-content">
                            <span className="wiki-hero-content-discussion">
                              {app.translator.trans('dl-wiki.forum.post_num')}：{this.tagItem[0].discussionCount()}
                            </span>
                            <span className="wiki-hero-content-views">
                              {app.translator.trans('dl-wiki.forum.view_num')}：{this.tagItem[0].viewsCount()}
                            </span>
                          </div>
                        </div>
                      )}
                    </a>
                  )}
                  <div class="separator"></div>
                  {this.attrs.tags === 'skyspire' && renderSkyspireDividerCloud()}
                </div>
                {this.attrs.tags === 'skyspire' ? (
                  <SkyspirePage tagId={this.tagItem?.[0]?.id()} />
                ) : (
                  <div className="IndexPage-toolbar-box">
                  {isWikiHero && (
                    <div className="wiki-tab-header">
                      <button
                        className={`wiki-tab-btn ${this.activeTab === 1 ? 'active' : ''}`}
                        onclick={() => {
                          this.activeTab = 1;
                          app.cache.activeTabTag = 1;
                          m.redraw();
                        }}
                      >
                        <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/wiki-btnicon4.png`} />
                        <span>{app.translator.trans('dl-wiki.forum.latest_data')}</span>
                      </button>
                      <button
                        className={`wiki-tab-btn ${this.activeTab === 2 ? 'active' : ''}`}
                        onclick={() => {
                          this.activeTab = 2;
                          app.cache.activeTabTag = 2;
                          m.redraw();
                        }}
                      >
                        <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/wiki-btnicon5.png`} />
                        <span>{app.translator.trans('dl-wiki.forum.posted_by_players')}</span>
                      </button>
                    </div>
                  )}
                  {this.activeTab === 1 && isWikiHero && this.discussion ? (
                    <div className="IndexPage-toolbar dl-discussion-container">
                      <div className="DiscussionPage-stream">
                        <PostStream discussion={this.discussion} stream={this.wikiStream} onPositionChange={() => { }} unLoadNext={true} />
                      </div>
                      <LinkButton className="TagView-load-more" href={app.route.discussion(this.discussion, 0)}>
                        {app.translator.trans('dl_discussion.forum.loading_more') + '>>>'}
                      </LinkButton>
                    </div>
                  ) : (
                    <div className="IndexPage-toolbar dl-discussion-container">
                      <div className="IndexPage-toolbar-lin">
                        <ul className="IndexPage-toolbar-view">{listItems(IndexPage.prototype.viewItems().toArray())}</ul>
                        <ul className="IndexPage-toolbar-action">{listItems(IndexPage.prototype.actionItems().toArray())}</ul>
                      </div>
                      <DiscussionList state={app.discussions} isAllTag={this.tagItem.length > 0 && this.tagItem[0].isAllTag()} />
                    </div>
                  )}
                  </div>
                )}
              </div>
            </div>
          </div>
          {this.attrs.tags !== 'skyspire' && !app.session.user?.isSuspended() && this.tagItem.length > 0 && this.tagItem[0].canStartDiscussion() && (
            <FloatPostButton />
          )}
        </main>
      )
    ) : (
      <main class="App-content" style="min-height: 100vh">
        {this.title()}
      </main>
    );
  });
  override(PagePagePC.prototype, 'headerSlideShowView', function (original) {
    return <HomepageCountdownHeader className="header-slide-show-view" defaultTopImage="main-img-ph.png" showCarousel={true} />;
  });
  override(UserCard.prototype, 'view', function (original) {
    // if (app.store.models.type == 'phone') {
    let user = this.attrs.user;
    // const controls = UserControls.controls(user, this).toArray();
    let color = user.color();
    let badges = user.badges().toArray();
    let userLevel = user?.userLevel();
    let levelConf = userLevel?.levelConf();
    let levelImg;
    let levelImgRes;
    let levelColor;
    let levelColorRes;
    let levelImgs = levelConf?.levelImg();
    if (levelImgs) {
      levelImgRes = JSON.parse(levelImgs);
      levelImg = levelImgRes[app.data.pkgLogo.id];
    }
    let levelColors = levelConf?.color();
    if (levelColors) {
      levelColorRes = JSON.parse(levelColors);
      levelColor = levelColorRes[app.data.pkgLogo.id];
    }

    this.time;
    let unreadNotificationCount = app.session.user!.unreadNotificationCount();
    let unreadPostNotificationCount = app.session.user!.unreadPostNotificationCount();
    let unreadLikeNotificationCount = app.session.user!.unreadLikeNotificationCount();
    let walletStatus = app.session.user && app.forum.attribute('walletStatus');
    const isIOSOrMacOS = /iPad|iPhone|iPod|Macintosh|Mac OS X/i.test(navigator.userAgent);
    const shouldShowWallet = !isIOSOrMacOS || Boolean(app.data['currentRole']);
    let joinTime = dayjs(user.joinTime()).format('LL');

    return (
      <div className={classList('UserCard', this.attrs.className)} style={color && { '--usercard-bg': color }}>
        <div className="darkenBackground new-darkenBackground">
          <div className="container extra-userCard-container">
            <div className="UserCard-profile">
              <div className={`UserCard-box ${user.isAdmin() ? 'admin' : ''}`}>
                {app.session.user == user && (
                  <LinkButton
                    className="person-pointNumber-container"
                  // href={history?.backUrl()}
                  >
                    <span className="person-pointNumer-icon">
                      <i class="fas fa-star"></i>
                    </span>
                    <span className="person-pointNumer">
                      {userLevel?.allIntegra() > 999
                        ? app.translator.trans('dl-person.forum.integra_more')
                        : app.translator.trans('dl-person.forum.integra', { integra: userLevel.allIntegra() })}
                    </span>
                  </LinkButton>
                )}
                <div className={`Perssson-msg-fiter ${user.isAdmin() ? 'admin' : ''}`}>
                  {this.attrs.editable ? (
                    <AvatarEditor user={user} className="UserCard-avatar" />
                  ) : (
                    <Link href={app.route.user(user)}>
                      <div className="UserCard-avatar">{avatar(user, { loading: 'eager' })}</div>
                      {/* {username(user)} */}
                    </Link>
                  )}
                  <div className="UserCard-right">
                    <div className="UserCard-identity-lin">
                      <h1 className="UserCard-identity">
                        <Button className="UserCard-identity-person" onclick={() => app.session.user === user && app.modal.show(NickNameModal)}>
                          {/* <span className="UserCard-identity-person-nickNameTitle">{app.translator.trans('dl-person.forum.nickName')}</span> */}
                          <span className="UserCard-identity-person-nickName UserCard-user-name">{nickname(user)}</span>
                          {app.session.user == user && <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-sr.png`}></img>}
                        </Button>
                      </h1>
                      <h1 className="">
                        {/* ID复制 */}
                        <>
                          <Button className="UserCard-identity-person" onclick={() => AlertUtil.copyToClipboar(user.uniqueID())}>
                            <span className="UserCard-identity-person-nickNameTitle">{app.translator.trans('dl-person.forum.ID')}</span>&nbsp;
                            <span className="UserCard-identity-person-nickName">{user.uniqueID()}</span>
                            <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-fz.png`}></img>
                          </Button>
                        </>
                      </h1>
                    </div>
                    <div class="person-center-containers">
                      <div class="person-center-blocks">
                        <div class="person-center-top">{app.translator.trans('dl-wiki.forum.create_time')}</div>
                        <div class="person-center-bottom">{joinTime}</div>
                      </div>
                      <div class="person-center-blocks">
                        <div class="person-center-top">{app.translator.trans('dl-wiki.forum.likes_number')}</div>
                        <div class="person-center-bottom">{user.likeCount()}</div>
                      </div>
                      {app.session.user === user && (
                        <div class="person-center-blocks" onclick={() => app.modal.show(RoleBindingModal)}>
                          <div class="person-center-top">{app.translator.trans('dl-wiki.forum.bind_role')}</div>
                          <div class="person-center-bottom">
                            {app.data['currentRole'] ? app.data['currentRole'].name : app.translator.trans('dl-pay.forum.operation.not_role')}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <h2 className="UserCard-segmentation"></h2>

                <h1 className="UserCard-identity person-grade-container person-grade-container-lin">
                  <div className='person-grade-content'>
                    {/* 经验值 */}
                    {ExperienceValuelBar.component({ user })}
                    {/* 等级 */}
                    <div className="person-grade-container">
                      <span className="person-grade-text">{app.translator.trans('dl-person.forum.experiences.grade')}</span>
                      <div className="DiscussionListItem-img-box">
                        <img src={levelImg} className="person-grade-img" />
                        <span
                          className="DiscussionListItem-img-lv"
                          style={`text-shadow: -1px 0 0 ${levelColor}, 0 -1px 0 ${levelColor},-1px -1px 0 ${levelColor}, 1px -1px 0 ${levelColor}, -1px 1px 0 ${levelColor}, 1px 1px 0 ${levelColor};`}
                        >
                          {userLevel?.levelConf()?.level()}
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* 等级奖励领取 */}
                  {/* {app.session.user === user && userLevel?.levelConf()?.level() > 1 && (
                    <Button
                      className="Button level-reward-btn"
                      disabled={app.data['levelRewardClaimed']}
                      onclick={() => {
                        const level = userLevel?.levelConf()?.level();
                        const role = app.data['currentRole'];
                        const roleRewards = user.roleRewards();
                        if (!role) {
                          app.modal.show(RoleBindingModal);
                          return;
                        }

                        // 获取已发放奖励的最后等级，默认为1
                        const lastClaimedLevel = roleRewards?.level || 0;

                        // 计算未领取的等级范围
                        const unclaimedLevels: number[] = [];
                        for (let i = lastClaimedLevel + 1; i <= level; i++) {
                          unclaimedLevels.push(i);
                        }

                        if (unclaimedLevels.length === 0) {
                          return; // 没有可领取的奖励
                        }

                        // 生成等级范围文本
                        let levelRangeText;
                        if (unclaimedLevels.length === 1) {
                          levelRangeText = `LV${unclaimedLevels[0]}`;
                        } else {
                          levelRangeText = `LV${unclaimedLevels[0]}-LV${unclaimedLevels[unclaimedLevels.length - 1]}`;
                        }

                        app.modal.show(RoleBindConfirmModal, {
                          onConfirm: () => {
                            return app
                              .request({
                                method: 'POST',
                                url: app.forum.attribute('apiUrl') + '/sdkSendRoleRewards',
                                body: { key: 'level' },
                              })
                              .then((res) => {
                                app.data['levelRewardClaimed'] = true;
                                return res;
                              });
                          },
                          confirmText: app.translator.trans('dl-optimization.forum.reward_sure', { level: levelRangeText, srvId: role.srvId, roleName: role.name }),
                          successText: app.translator.trans('dl-optimization.forum.reward_send'),
                        });
                      }}
                    >
                      {app.data['levelRewardClaimed'] || userLevel?.levelConf()?.level() == user.roleRewards()?.level ? app.translator.trans('dl-optimization.forum.received') : app.translator.trans('dl-optimization.forum.click_receive')}
                    </Button>
                  )} */}
                </h1>
              </div>
              {app.session.user === user && (
                <>
                  {/* 钱包 */}
                  {shouldShowWallet && (
                    <div className="User-wallet">
                      <div className="left">{app.translator.trans('dl-pay.forum.user.wallet_balance')}</div>
                      <div className="right">
                        <div className="money">${app.store.balance ? app.store.balance : '0'}</div>
                        {walletStatus && (
                          <div className="btn">
                            <a className="" href={app.route('pay', { type: 'postPayed' })}>
                              {app.translator.trans('dl-pay.forum.user.wallet_recharge')}
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {/* 中间按钮 */}

                  {/* 邮箱那些按钮 */}
                  <div class="person-center-containers">
                    <div class="person-center-blocks">
                      <div class="person-center-top">
                        <LinkButton className={unreadNotificationCount ? 'Notification-unread' : ''} href={app.route('notifications')}>
                          <img className="person-center-top-img" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-yhxx.png`} />
                        </LinkButton>
                      </div>
                      <div class="person-center-bottom person-center-bottom-while">{app.translator.trans('dl-person.forum.mail')}</div>
                    </div>
                    <div class="person-center-blocks">
                      <div class="person-center-top">
                        <LinkButton
                          className={unreadPostNotificationCount ? 'Notification-unread' : ''}
                          href={app.route('notifications.comment', { type: 'newPost' })}
                        >
                          <img className="person-center-top-img" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-bhf.png`} />
                        </LinkButton>
                      </div>
                      <div class="person-center-bottom person-center-bottom-while">{app.translator.trans('dl-person.forum.comment')}</div>
                    </div>
                    <div class="person-center-blocks">
                      <div class="person-center-top">
                        <LinkButton
                          className={unreadLikeNotificationCount ? 'Notification-unread' : ''}
                          href={app.route('notifications.likes', { type: 'postLiked' })}
                        >
                          <img className="person-center-top-img" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-bdz.png`} />
                        </LinkButton>
                      </div>
                      <div class="person-center-bottom person-center-bottom-while">{app.translator.trans('dl-person.forum.likeMsg')}</div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
    // } else {
    //   return original();
    // }
  });
  override(PayPage.prototype, 'UserInfoBox', function (original) {
    let user = app.session.user;

    let userLevel = user?.userLevel();

    return (
      <div className="Wallet-userinfo">
        <div className="user-avatar-box">
          <div className="user-avatar">{avatar(user)}</div>
        </div>
        <div className="user-info">
          <div className="info-item">
            <span className="UserCard-identity-person-nickNameTitle">{app.translator.trans('dl-person.forum.nickName')}</span>
            <span className="UserCard-identity-person-nickName">{nickname(user)}</span>
          </div>
          <div className="info-item">
            <Button className="UserCard-identity-person" onclick={() => AlertUtil.copyToClipboar(user.uniqueID())}>
              <span className="UserCard-identity-person-nickNameTitle">{app.translator.trans('dl-person.forum.ID')}</span>&nbsp;
              <span className="UserCard-identity-person-nickName">{user.uniqueID()}</span>
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-fz.png`}></img>
            </Button>
          </div>
        </div>
        <LinkButton
          className="person-pointNumber-container"
        // href={history?.backUrl()}
        >
          <span className="person-pointNumer-icon">
            <i class="fas fa-star"></i>
          </span>
          <span className="person-pointNumer">
            {userLevel?.allIntegra() > 999
              ? app.translator.trans('dl-person.forum.integra_more')
              : app.translator.trans('dl-person.forum.integra', { integra: userLevel.allIntegra() })}
          </span>
        </LinkButton>
        <div className="wallet-balance">
          <div className="name">{app.translator.trans('dl-pay.forum.user.current_wallet_balance')}</div>
          <div className="balance">

            ${this.balance.toFixed(2)}
          </div>
        </div>
        <LinkButton className="UserCard-identity-person-setting" href={app.route('settings2')}>
          <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-szbai.png`} />
        </LinkButton>
      </div>
    );
  });
  // 覆写钱包页
  override(PayPage.prototype, 'view', function (original) {
    let baseUrl = app.forum.attribute('baseUrl');
    let userLink = app.data.pkgLogo.userLink;
    let localeUserLink = '';
    if (userLink) {
      // 将字符串映射转换为 JavaScript 对象
      const obj = JSON.parse(userLink);
      // 创建 Map 对象并初始化
      const map = new Map(Object.entries(obj));
      // 获取特定键的值
      localeUserLink = map.get(app.data.locale);
    }
    return (
      <div className="Wallet">
        <div className="wallet-user-box">{this.UserInfoBox()}</div>
        <div className="wallet-title">{app.translator.trans('dl-pay.forum.user.my_wallet')}</div>
        <div className="wallet-tip">
          <p>{app.translator.trans('dl-optimization.forum.warn.pay_balance_textOne')} <span className='discount'>5%</span> {app.translator.trans('dl-optimization.forum.warn.pay_balance_textTwo')}</p>
          <div className="bottom">
            <p>
              {app.translator.trans('dl-pay.forum.comfirm.more_use')}
              <a href={localeUserLink ? (localeUserLink.includes('http') ? localeUserLink : baseUrl + localeUserLink) : '#'}>
                {/* <u onclick={() => app.modal.show(AgreementModal, { data: userAgreement, title: app.translator.trans('dl-pay.forum.comfirm.user_agreement_text') }, true)}> */}
                {app.translator.trans('dl-pay.forum.comfirm.user_agreement')}
                {/* </u> */}
              </a>,
              {app.translator.trans('dl-optimization.forum.warn.pay_balance_textThree')}<a className='link' onclick={() => {
                if (!app.session.user) {
                  app.modal.show(LogInModal);
                  return;
                }
                let entranceId = app.data.pkgLogo.entranceId;
                // 打开反馈页面
                AIHelpSupport.show(entranceId ? entranceId : 'E001');
              }}> {app.translator.trans('dl-optimization.forum.warn.pay_balance_textFour')}</a>
            </p>
            <span>
              {this.refund == 0 || this.refund == undefined
                ? ''
                : app.translator.trans('dl-pay.forum.operation.refund_review_in_progress', { refund: this.refund })}
            </span>
          </div>
        </div>

        <div className="Wallet-recharge-box">
          <div className="recharge-box">
            {this.commodityList &&
              this.commodityList.map((item, index) => (
                <div className="recharge-item">
                  <div className="recharge-bg">
                    <div className="recharge-item-left">
                      <div className="recharge-item-name">
                        {app.translator.trans('dl-pay.forum.order.recharge_label')}
                        <span>{item.goodsId}</span>
                      </div>
                      {/* <div className="recharge-item-name">充值$123.00</div> */}

                      {/* <div className='recharge-item-discount'>-10%</div> */}
                    </div>
                    <div className="recharge-item-right">
                      {
                        this.pcChargeDiscount < 100 ? (
                          <>
                            <div className='recharge-item-discount'>-{100 - this.pcChargeDiscount}%</div>
                            <div className="recharge-item-price">
                              <div className='original-price'>${item.money.toFixed(2)}</div>
                              <div className="current-price">${(item.money * this.pcChargeDiscount / 100).toFixed(2)}</div>
                            </div>
                          </>

                        ) : (
                          <div className="recharge-item-price">
                            {/* <div className='original-price'>${item.money.toFixed(2)}</div> */}
                            <div className="current-price">${item.money.toFixed(2)}</div>
                            {/* <div className="current-price">$123.00</div> */}
                          </div>
                        )
                      }
                      <div
                        className="recharge-item-btn"
                        onclick={() => {
                          app.modal.show(PayConfirmModal, { price: item.money, payType: this.payType, goodsId: item.goodsId, pcChargeDiscount: this.pcChargeDiscount });
                        }}
                      >
                        {app.translator.trans('dl-pay.forum.order.recharge')}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* <div className="wallet-remind">

          <p>
            <u
              className="wallet-refund"
              onclick={() => {
                if (this.balance == 0) {
                  AlertUtil.onWarn(app, app.translator.trans('dl-response.forum.warn.balance_is_null'));
                  return;
                }
                app.modal.show(RefundModal, {
                  balance: this.balance,
                  sdkUserPc: () => {
                    this.sdkUserPc();
                  },
                });
              }}
            >
              {app.translator.trans('dl-pay.forum.user.my_want_refund')}
            </u>
          </p>
        </div> */}
      </div>
    );
  });

  // ============ 覆写 SignUpModal：左右分栏布局 ============
  override(SignUpModal.prototype, 'className', function (original) {
    return 'Modal--small SignUpModal SignUpModal--split';
  });

  override(SignUpModal.prototype, 'title', function (original) {
    let helpUrl = app.forum.attribute('baseUrl') + '/p/help';
    if (app.data.pkgLogo && app.data.pkgLogo.helpLinkUrl) {
      helpUrl = app.data.pkgLogo.helpLinkUrl;
    }
    return (
      <div className="SignUpModal-title-row">
        <h3>{app.translator.trans('core.forum.sign_up.title')}</h3>
        <a className="SignUpModal-help-btn" href={helpUrl} target="_blank" rel="noopener noreferrer" title="Help">
          <i className="fas fa-question-circle"></i>
        </a>
      </div>
    );
  });

  override(SignUpModal.prototype, 'content', function (original) {
    let pkgLogo = app.data.pkgLogo;
    let localePkgLogo = '';
    try {
      const obj = JSON.parse(pkgLogo.pkgLogo);
      const map = new Map(Object.entries(obj));
      localePkgLogo = map.get(app.data.locale);
    } catch (e) { }

    return (
      <div className="SignUpModal-content">
        {/* 右侧 - 注册新账号 */}
        <div className="SignUpModal-right">
          <div className="Modal-body">
            <div className="Form Form--centered">{this.fields().toArray()}</div>
            <div className="Modal-footer">{this.footer()}</div>
          </div>
        </div>
      </div>
    );
  });

  // 修改 fields 方法：移除 username 字段，只保留 email、code、password
  override(SignUpModal.prototype, 'fields', function (original) {
    const items = new ItemList();

    const emailLabel = extractText(app.translator.trans('core.forum.sign_up.email_placeholder'));
    const passwordLabel = extractText(app.translator.trans('core.forum.sign_up.password_placeholder'));
    const codeLabel = extractText(app.translator.trans('dl_sendCode.forum.code_placeholder'));

    items.add(
      'email',
      <div className="Form-group">
        <input
          className="FormControl"
          name="email"
          type="email"
          placeholder={emailLabel}
          aria-label={emailLabel}
          bidi={this.email}
          disabled={this.loading || this.isProvided('email')}
        />
      </div>,
      30
    );

    items.add(
      'code',
      <div className="Form-group input-code">
        <input
          className="FormControl"
          name="code"
          placeholder={codeLabel}
          aria-label={codeLabel}
          bidi={this.code}
          disabled={this.loading || this.isProvided('code')}
        />
        <button className="Button Button--icon CommandButton" type="button" onclick={this.sendCode.bind(this)} disabled={this.isSending()}>
          <span>{this.isSending() ? String(this.secondsLeft()) + app.translator.trans('dl_sendCode.forum.send_code_time') : app.translator.trans('dl_sendCode.forum.send_code')}</span>
        </button>
      </div>,
      20
    );

    if (!this.attrs.token) {
      items.add(
        'password',
        <div className="Form-group">
          <input
            className="FormControl"
            name="password"
            type="password"
            autocomplete="new-password"
            placeholder={passwordLabel}
            aria-label={passwordLabel}
            bidi={this.password}
            disabled={this.loading}
          />
        </div>,
        10
      );
    }

    items.add(
      'submit',
      <div className="Form-group">
        <Button className="Button Button--primary Button--block" type="submit" loading={this.loading}>
          {app.translator.trans('core.forum.sign_up.submit_button')}
        </Button>
      </div>,
      -10
    );

    items.add(
      'hint',
      <div className="Form-group hint">
        <span>{app.translator.trans('dl-response.forum.login.hint_text')}</span>
      </div>,
      -20
    );

    return items;
  });

  // 覆写 onsubmit：注册前校验 + 邮箱已注册检测 + 注册后头像昵称选择流程
  override(SignUpModal.prototype, 'onsubmit', function (original, e) {
    e.preventDefault();
    this.loading = true;

    const body = this.submitData();
    if (!CommentUtil.checkEmail(body.email)) {
      this.loading = false;
      CommentUtil.onWarn(app, app.translator.trans('dl-alert.forum.email_rule'));
      return;
    }
    if (!CommentUtil.checkPwd(body.password)) {
      this.loading = false;
      CommentUtil.onWarn(app, app.translator.trans('dl-alert.forum.pwd_rule'));
      return;
    }
    if (!CommentUtil.checkCode(body.code)) {
      this.loading = false;
      CommentUtil.onWarn(app, app.translator.trans('dl_sendCode.forum.code_rule'));
      return;
    }

    app
      .request({
        url: app.forum.attribute('baseUrl') + '/register',
        method: 'POST',
        body,
      })
      .then((res: any) => {
        // 注册成功，关闭注册弹窗，弹出头像昵称选择弹窗
        this.loading = false;
        app.modal.close();

        // 等待 session 更新
        setTimeout(() => {
          app.modal.show(AvatarNicknameModal, { userId: Number(res.data.id) });
        }, 500);
      }, this.loaded.bind(this));
  });

  override(SignUpModal.prototype, 'submitData', function (original) {
    const authData = this.attrs.token ? { token: this.attrs.token } : { password: this.password() };
    const emailVal = this.email() || '';

    const data: any = {
      email: emailVal,
      code: this.code(),
      fromFlorum: true,
      ...authData,
    };

    return data;
  });

  // 悬浮通知弹框：等级奖励未领取 / 未读系统通知
  function FloatingNotificationBanner() {
    // 查询未读等级奖励通知
    const hasRewardToClaim = (() => {
      if (!app.cache.floatingRewardNotifications) {
        app.cache.floatingRewardNotifications = new NotificationListState({
          filter: {
            type: ['userRoleRewardWaitAccept', 'userRoleRewardIsSended'],
            isUnread: true,
          },
        });
        app.cache.floatingRewardNotifications.load();
        app.cache.rewardNotificationsMarkedRead = false;
      }
      const state = app.cache.floatingRewardNotifications;
      if (state.isLoading() || !state.hasItems()) return false;
      const pages = state.getPages();
      if (!pages || pages.length === 0 || !pages[0].items || pages[0].items.length === 0) return false;

      // 如果有未读的等级奖励通知且未标记为已读，调用接口标记为已读
      if (pages[0].items.length > 0 && !app.cache.rewardNotificationsMarkedRead) {
        app.request({
          url: app.forum.attribute('apiUrl') + '/notifications/read',
          method: 'POST',
          body: { type: 3 },
        });
        app.cache.rewardNotificationsMarkedRead = true;
      }
      return true;
    })();

    // 查询未读系统消息
    const unreadSystemCount = (() => {
      if (!app.cache.floatingSystemNotifications) {
        app.cache.floatingSystemNotifications = new NotificationListState({
          filter: {
            type: { '!': ['newPost', 'userMentioned', 'postLiked'] },
            isUnread: true,
          },
        });
        app.cache.floatingSystemNotifications.load();
      }
      const state = app.cache.floatingSystemNotifications;
      if (state.isLoading() || !state.hasItems()) return 0;
      const pages = state.getPages();
      if (!pages || pages.length === 0 || !pages[0].items || pages[0].items.length === 0) return 0;
      return pages[0].items[0].count() || 0;
    })();

    const hasReward = hasRewardToClaim;
    const hasSystemNotif = unreadSystemCount > 0;

    // 初始化关闭状态
    if (!app.cache.floatingBannerDismissed) {
      app.cache.floatingBannerDismissed = {};
    }

    // 如果没有需要显示的内容，或者已关闭，则不渲染
    if (!hasReward && !hasSystemNotif) return null;

    // 确定显示的文本和跳转链接
    let text = '';
    let link = '';
    let bannerKey = '';

    if (hasReward) {
      text = app.translator.trans('dl-optimization.forum.userRoleRewardWaitAccept_text');
      link = app.route.user(app.session.user);
      bannerKey = 'reward';
    } else {
      text = app.translator.trans('dl-optimization.forum.received_msg', { unreadSystemCount: unreadSystemCount });
      link = '';
      bannerKey = 'system';
    }

    if (app.cache.floatingBannerDismissed[bannerKey]) return null;

    return (
      <div className="FloatingNotificationBanner">
        <div className="FloatingNotificationBanner-content">
          {link ? (
            <LinkButton href={link} className="FloatingNotificationBanner-link" onclick={() => {
              app.cache.floatingBannerDismissed[bannerKey] = true;
            }}>
              {text}
            </LinkButton>
          ) : (
            <span className="FloatingNotificationBanner-text">{text}</span>
          )}
          <button className="FloatingNotificationBanner-close" onclick={() => {
            app.cache.floatingBannerDismissed[bannerKey] = true;
            m.redraw();
          }}>
            <i className="fas fa-times"></i>
          </button>
        </div>
      </div>
    );
  }

  // 通知分类：根据 tab 切换请求数据
  const REPLY_TYPES = ['newPost', 'userMentioned'];
  const LIKE_TYPES = ['postLiked'];

  // 用一个临时对象存储当前选中的 tab
  if (!app.cache.notificationTab) {
    app.cache.notificationTab = 'reply';
  }

  function getNotificationFilter(tab: string) {
    if (tab === 'reply') return { type: REPLY_TYPES };
    if (tab === 'like') return { type: LIKE_TYPES };
    // 系统分类：排除回复和点赞类型
    return {
      type: { '!': [...REPLY_TYPES, ...LIKE_TYPES] }
    };
  }

  function loadNotificationsByTab(tab: string) {
    app.cache.notificationTab = tab;
    app.notifications = new NotificationListState({
      filter: getNotificationFilter(tab),
    });
    app.notifications.load();
    m.redraw();
  }

  // 覆写 NotificationsPage 的 oninit，根据当前 tab 请求数据
  override(NotificationsPage.prototype, 'oninit', function (original, vnode) {
    Page.prototype.oninit.call(this, vnode);

    app.history.push('notifications', extractText(app.translator.trans('core.forum.notifications.title')));

    this.bodyClass = 'App--notifications';
    if (!app.cache.scrollTop) {
      app.cache.scrollTop = {};
    }

    // 根据当前 tab 创建对应的 NotificationListState 并加载数据
    loadNotificationsByTab(app.cache.notificationTab || 'reply');
  });

  override(NotificationList.prototype, 'view', function (original) {
    const state = this.attrs.state;
    const title = this.attrs.title;
    const currentTab = app.cache.notificationTab || 'reply';
    const unreadCounts = state.unreadCounts || app.cache.notificationUnreadCounts || { reply: 0, like: 0, system: 0 };
    this.type = currentTab === 'reply' ? 1 : currentTab === 'like' ? 2 : 4;

    return (
      <div className="NotificationList">
        <div className="NotificationList-header">
          <h4 className="App-titleControl App-titleControl--text">{title ? title : app.translator.trans('core.forum.notifications.title')}</h4>

          <div className="App-primaryControl">{this.controlItems().toArray()}</div>
        </div>

        <div className="NotificationList-tabs">
          <div
            className={'NotificationList-tab' + (currentTab === 'reply' ? ' active' : '')}
            onclick={() => loadNotificationsByTab('reply')}
          >
            {app.translator.trans('dl-optimization.forum.reply')}
            {unreadCounts.reply > 0 && <span className="NotificationList-unreadDot" aria-hidden="true" />}
          </div>
          <div
            className={'NotificationList-tab' + (currentTab === 'like' ? ' active' : '')}
            onclick={() => loadNotificationsByTab('like')}
          >
            {app.translator.trans('dl-optimization.forum.like')}
            {unreadCounts.like > 0 && <span className="NotificationList-unreadDot" aria-hidden="true" />}
          </div>
          <div
            className={'NotificationList-tab' + (currentTab === 'system' ? ' active' : '')}
            onclick={() => loadNotificationsByTab('system')}
          >
            {app.translator.trans('dl-optimization.forum.system')}
            {unreadCounts.system > 0 && <span className="NotificationList-unreadDot" aria-hidden="true" />}
          </div>
        </div>

        <div className="NotificationList-content">{this.content(state)}</div>
      </div>
    );
  });

  override(NotificationList.prototype, 'content', function (original, state) {
    if (state.isLoading()) {
      return <LoadingIndicator className="LoadingIndicator--block" />;
    }

    if (state.hasItems()) {
      return state.getPages().map((page) => {
        const groups = [];
        const discussions = {};

        page.items.forEach((notification) => {
          const subject = notification.subject();
          if (typeof subject === 'undefined') return;
          let discussion = null;
          if (subject instanceof Discussion) discussion = subject;
          else if (subject && subject.discussion) discussion = subject.discussion();

          const key = discussion ? discussion.id() : (notification.contentType() == 'sendNotice' ? -1 : 0);

          discussions[key] = discussions[key] || { discussion: discussion, notifications: [] };
          discussions[key].notifications.push(notification);
          if (groups.indexOf(discussions[key]) === -1) {
            groups.push(discussions[key]);
          }
        });

        return groups.map((group) => {
          const badges = group.discussion && group.discussion.badges().toArray();
          let selectOne = 0;
          if (!group.discussion) {
            if (group.notifications[0].contentType() == 'sendNotice') {
              selectOne = 1;
            } else {
              selectOne = 2;
            }
          }
          return (
            <div className="NotificationGroup">
              {selectOne == 0 && (
                <Link className="NotificationGroup-header" href={app.route.discussion(group.discussion)}>
                  {badges && !!badges.length && <ul className="NotificationGroup-badges badges">{listItems(badges)}</ul>}
                  <span>{group.discussion.title()}</span>
                </Link>
              )}

              {selectOne == 2 && (
                <div className="NotificationGroup-header">{app.forum.attribute('title')}</div>
              )}

              {selectOne == 1 && (
                <div className="NotificationGroup-header">{app.translator.trans('dl-send.forum.title')}</div>
              )}

              <ul className="NotificationGroup-content">
                {group.notifications.map((notification) => {
                  const NotificationComponent = app.notificationComponents[notification.contentType()];
                  return (
                    !!NotificationComponent && (
                      <li>
                        <NotificationComponent notification={notification} />
                      </li>
                    )
                  );
                })}
              </ul>
            </div>
          );
        });
      });
    }

    return <div className="NotificationList-empty">{app.translator.trans('core.forum.notifications.empty_text')}</div>;
  });
}
